function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));

      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;

      // Update quantity
      const newValue = Math.max(quantity + change, 1);

      // Check min and max values
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;

      // Update input value
      this.input.value = newValue;

      // Dispatch change event
      this.input.dispatchEvent(this.changeEvent);

      // Update button states
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();

      document.addEventListener('click', this.onWindowClick.bind(this));

      // Add functionality to button
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
    }

    onWindowClick(event) {
      if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      this.classList.add('open');
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
      this.classList.remove('open');
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');
          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keypress', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.drawer.setAttribute('open', '');
        this.drawer.querySelector('.product-modal__toggle').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
      this.onPointerDownBound = this.onPointerDown.bind(this);
      this.onPointerMoveBound = this.onPointerMove.bind(this);
      this.onPointerEndBound = this.onPointerEnd.bind(this);
      this.dragActive = false;
      /** Pointer down on carousel viewport but drag not committed yet (no setPointerCapture — lets <a href> receive clicks). */
      this.carouselDragPending = false;
      this.dragMoved = false;
      this.dragPointerId = null;
      this.velocityScroll = 0;
      this.previousScrollLeft = 0;
      this.lastMoveTime = 0;
      this.momentumRaf = null;
    }
    cancelCarouselMomentum() {
      if (this.momentumRaf) {
        cancelAnimationFrame(this.momentumRaf);
        this.momentumRaf = null;
      }
    }
    disconnectedCallback() {
      this.cancelCarouselMomentum();
      if (this._collectionListFooterRo) {
        this._collectionListFooterRo.disconnect();
        this._collectionListFooterRo = null;
      }
      if (!this.viewport) {
        return;
      }
      this.viewport.removeEventListener('pointerdown', this.onPointerDownBound);
      this.viewport.removeEventListener('pointermove', this.onPointerMoveBound);
      this.viewport.removeEventListener('pointerup', this.onPointerEndBound);
      this.viewport.removeEventListener('pointercancel', this.onPointerEndBound);
      this.endCarouselDrag(false);
    }
    connectedCallback() {
      const osOptions =
        this.classList.contains('collection-tabs__carousel') ||
        this.classList.contains('collection-list__theme-scroll') ||
        this.classList.contains('featured-collection-list__carousel') ?
          {
            scrollbars: {
              // Collection list: dragScroll fights nested <a href> (tiles); ThemeScroll handles drag.
              dragScroll: !this.classList.contains('collection-list__theme-scroll'),
              clickScroll: true,
            },
          } :
          {};

      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, osOptions);

      this.init();
      requestAnimationFrame(() => this.updateCollectionListCarouselFooterChrome());
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides.length > 1 ?
          this.slides[1].offsetLeft - this.slides[0].offsetLeft :
          this.slides[0].offsetWidth;
        this.syncScrollBoundaries();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
      this.syncScrollBoundaries();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    /**
     * Fin de carrusel: usar scrollWidth - clientWidth (no offsetWidth) y margen por subpíxeles / zoom.
     * Antes: igualdad estricta con offsetWidth + floor(scrollLeft) → reachedEnd casi nunca true al final.
     */
    syncScrollBoundaries() {
      if (!this.viewport) {
        return;
      }
      const vp = this.viewport;
      const maxScroll = Math.max(0, vp.scrollWidth - vp.clientWidth);
      const sl = vp.scrollLeft;
      const epsilon = 3;
      this.reachedEnd = maxScroll <= epsilon || sl >= maxScroll - epsilon;
      this.onNavDisabled();
      this.updateCollectionListCarouselFooterChrome();
    }
    /**
     * Collection list carousel: sin overflow horizontal no hace falta la franja alta de 52px
     * (barra + flechas). Compactamos el padding inferior vía list-collections.css.
     */
    updateCollectionListCarouselFooterChrome() {
      if (!this.classList.contains('collection-list__carousel') || !this.viewport) {
        return;
      }
      const epsilon = 3;
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      this.classList.toggle('theme-scroll--compact-carousel-footer', maxScroll <= epsilon);
    }
    setListeners() {
      if (this.nav) {
        this.nav.addEventListener('click', this.onNavClick.bind(this));
      }
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
      if (this.classList.contains('collection-list__carousel') && typeof ResizeObserver !== 'undefined') {
        this._collectionListFooterRo = new ResizeObserver(() => this.updateCollectionListCarouselFooterChrome());
        this._collectionListFooterRo.observe(this.viewport);
      }
      if (this.shouldEnableCarouselDrag()) {
        this.viewport.addEventListener('pointerdown', this.onPointerDownBound);
        this.viewport.addEventListener('pointermove', this.onPointerMoveBound);
        this.viewport.addEventListener('pointerup', this.onPointerEndBound);
        this.viewport.addEventListener('pointercancel', this.onPointerEndBound);
      }
    }
    shouldEnableCarouselDrag() {
      return this.classList.contains('featured-collection-list__carousel') ||
        this.classList.contains('collection-tabs__carousel') ||
        this.classList.contains('collection-list__carousel') ||
        this.classList.contains('collection-list__theme-scroll');
    }
    /** Collection list: en viewport mobile el scroll táctil nativo del viewport encaja mejor que pointer-drag + links anidados. */
    collectionListUseNativeTouchScroll() {
      const isList =
        this.classList.contains('collection-list__carousel') ||
        this.classList.contains('collection-list__theme-scroll');
      if (!isList) return false;
      return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches;
    }
    onPointerDown(e) {
      if (!this.viewport || e.button !== 0) {
        return;
      }
      if (this.collectionListUseNativeTouchScroll()) {
        return;
      }
      if (e.target.closest('.theme-scroll-nav, .flickity-nav, button[name="prev"], button[name="next"]')) {
        return;
      }
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      if (maxScroll <= 0) {
        return;
      }
      // Defer setPointerCapture until the user moves horizontally. Immediate capture
      // steals the gesture from nested <a href> so taps never navigate (collection list, etc.).
      this.cancelCarouselMomentum();
      this.carouselDragPending = true;
      this.dragActive = false;
      this.dragMoved = false;
      this.dragPointerId = e.pointerId;
      this.pointerDownX = e.clientX;
      this.pointerDownScrollLeft = this.viewport.scrollLeft;
      this.previousScrollLeft = this.viewport.scrollLeft;
      this.lastMoveTime = performance.now();
      this.velocityScroll = 0;
    }
    onPointerMove(e) {
      if (this.collectionListUseNativeTouchScroll()) {
        return;
      }
      if (e.pointerId !== this.dragPointerId || !this.viewport) {
        return;
      }
      const dx = e.clientX - this.pointerDownX;
      const dragCommitPx = 8;
      if (this.carouselDragPending && !this.dragActive) {
        if (Math.abs(dx) <= dragCommitPx) {
          return;
        }
        this.carouselDragPending = false;
        this.dragActive = true;
        this.dragMoved = true;
        try {
          this.viewport.setPointerCapture(e.pointerId);
        } catch (err) { /* noop */ }
        this.classList.add('theme-scroll--is-dragging');
        this.cancelCarouselMomentum();
        this.previousScrollLeft = this.viewport.scrollLeft;
        this.lastMoveTime = performance.now();
        this.velocityScroll = 0;
      }
      if (!this.dragActive) {
        return;
      }
      if (Math.abs(dx) > 3) {
        this.dragMoved = true;
      }
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const newScroll = Math.max(0, Math.min(maxScroll, this.pointerDownScrollLeft - dx));
      const now = performance.now();
      const dtMs = now - this.lastMoveTime;
      if (dtMs > 0 && dtMs < 80 && this.dragMoved) {
        const dScroll = newScroll - this.previousScrollLeft;
        const instVel = (dScroll / dtMs) * 1000;
        this.velocityScroll = this.velocityScroll * 0.55 + instVel * 0.45;
      }
      this.lastMoveTime = now;
      this.previousScrollLeft = newScroll;
      this.viewport.scrollLeft = newScroll;
      this.onScroll();
    }
    onPointerEnd(e) {
      if (this.collectionListUseNativeTouchScroll()) {
        return;
      }
      if (e.pointerId !== this.dragPointerId) {
        return;
      }
      if (this.carouselDragPending && !this.dragActive) {
        this.carouselDragPending = false;
        this.dragPointerId = null;
        return;
      }
      if (!this.dragActive) {
        return;
      }
      try {
        this.viewport.releasePointerCapture(e.pointerId);
      } catch (err) { /* noop */ }
      if (this.dragMoved) {
        const vp = this.viewport;
        const swallow = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          vp.removeEventListener('click', swallow, true);
        };
        vp.addEventListener('click', swallow, {
          capture: true,
          once: true
        });
      }
      this.endCarouselDrag(false);
      if (this.dragMoved && this.shouldEnableCarouselDrag()) {
        const vAbs = Math.abs(this.velocityScroll);
        if (vAbs > 55) {
          this.startCarouselMomentum();
        } else {
          this.snapCarouselToNearestSlide();
        }
      }
    }
    endCarouselDrag(resetMoved) {
      this.carouselDragPending = false;
      this.dragActive = false;
      this.dragPointerId = null;
      this.classList.remove('theme-scroll--is-dragging');
      if (resetMoved) {
        this.dragMoved = false;
      }
    }
    /**
     * Inercia al soltar + snap a la tarjeta más cercana (ThemeScroll carruseles LOP).
     */
    startCarouselMomentum() {
      this.cancelCarouselMomentum();
      const vp = this.viewport;
      if (!vp) {
        return;
      }
      let v = this.velocityScroll;
      let lastT = performance.now();
      const friction = 3.35;
      const minVel = 22;
      const tick = (now) => {
        if (!vp.isConnected) {
          this.momentumRaf = null;
          return;
        }
        const dtSec = Math.min(0.045, (now - lastT) / 1000);
        lastT = now;
        const maxScroll = Math.max(0, vp.scrollWidth - vp.clientWidth);
        let sl = vp.scrollLeft;
        sl += v * dtSec;
        if (sl <= 0) {
          vp.scrollLeft = 0;
          this.onScroll();
          this.momentumRaf = null;
          this.snapCarouselToNearestSlide();
          return;
        }
        if (sl >= maxScroll) {
          vp.scrollLeft = maxScroll;
          this.onScroll();
          this.momentumRaf = null;
          this.snapCarouselToNearestSlide();
          return;
        }
        vp.scrollLeft = sl;
        this.onScroll();
        v *= Math.exp(-friction * dtSec);
        if (Math.abs(v) < minVel) {
          this.momentumRaf = null;
          this.snapCarouselToNearestSlide();
          return;
        }
        this.momentumRaf = requestAnimationFrame(tick);
      };
      this.momentumRaf = requestAnimationFrame(tick);
    }
    snapCarouselToNearestSlide() {
      const vp = this.viewport;
      if (!vp || !this.slides || !this.slides.length) {
        return;
      }
      const maxScroll = Math.max(0, vp.scrollWidth - vp.clientWidth);
      const cur = vp.scrollLeft;
      let bestTarget = cur;
      let bestDist = Infinity;
      for (let i = 0; i < this.slides.length; i++) {
        const slide = this.slides[i];
        const rectS = slide.getBoundingClientRect();
        const rectV = vp.getBoundingClientRect();
        const alignTarget = cur + (rectS.left - rectV.left);
        const t = Math.max(0, Math.min(maxScroll, alignTarget));
        const d = Math.abs(t - cur);
        if (d < bestDist) {
          bestDist = d;
          bestTarget = t;
        }
      }
      if (bestDist < 0.5) {
        this.onScroll();
        return;
      }
      vp.scrollTo({
        left: bestTarget,
        behavior: 'smooth'
      });
      const finalize = () => {
        this.onScroll();
      };
      window.setTimeout(finalize, 350);
      window.setTimeout(finalize, 600);
    }
    onScroll() {
      this.syncScrollBoundaries();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      this.cancelCarouselMomentum();
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (!this.viewport) {
        return;
      }
      const sl = this.viewport.scrollLeft;
      const atStart = sl <= 1;
      if (this.navPrev) {
        this.navPrev.disabled = atStart ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      if (this.classList.contains('collection-tabs__carousel') ||
          this.classList.contains('collection-list__carousel') ||
          this.classList.contains('featured-collection-list__carousel')) {
        if (this.navPrev) this.navPrev.style.transform = '';
        if (this.navNext) this.navNext.style.transform = '';
        return;
      }
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});


// Metadatos de carga del colorMap (theme JSON vs fallback). Sirve para logs [LOP FALTANTES] y debug en consola.
function _setLopColorMapConfigMeta(partial) {
  window.lopColorMapConfigMeta = Object.assign(
    {
      themeJsonPresent: false,
      themeJsonLength: 0,
      themeJsonParseOk: false,
      themeJsonParseError: null,
      activeMapSource: 'unknown',
      mapKeyCount: 0,
      lopEnableColorSwatches: null,
      hint: ''
    },
    partial || {}
  );
  return window.lopColorMapConfigMeta;
}

/**
 * Normaliza lop_color_map_json antes de JSON.parse: quita comas finales ilegales antes de } o ]
 * (muy frecuente al pegar/editar el JSON en el personalizador; Shopify guarda el string tal cual).
 */
function _lopSanitizeColorMapJsonString(str) {
  if (str == null || typeof str !== 'string') return '';
  let s = str.trim();
  let prev;
  do {
    prev = s;
    s = s.replace(/,\s*([}\]])/g, '$1');
  } while (s !== prev);
  return s;
}

// FUNCIÓN para cargar configuración de colores desde theme settings
function loadColorMapFromSettings() {
  // Debug completo de la configuración
  console.log('🔍 Debug completo de settings:', {
    windowShopify: !!window.Shopify,
    shopifyTheme: !!window.Shopify?.theme,
    shopifySettings: !!window.Shopify?.theme?.settings,
    allSettings: window.Shopify?.theme?.settings,
    enableSwitch: window.Shopify?.theme?.settings?.lop_enable_color_swatches,
    colorMapJson: window.Shopify?.theme?.settings?.lop_color_map_json ? 'Presente' : 'Ausente'
  });
  
  // NUEVA LÓGICA: Intentar cargar JSON PRIMERO, independientemente del checkbox
  const colorMapJson = window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && 
                       window.Shopify.theme.settings.lop_color_map_json;
  const isEnabled = window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && 
                   window.Shopify.theme.settings.lop_enable_color_swatches;

  const jsonStr = colorMapJson != null ? String(colorMapJson) : '';
  const jsonLooksEmpty = !jsonStr.trim() || jsonStr.trim() === '{}';

  if (!jsonLooksEmpty) {
    console.log('✅ Encontrado JSON en theme settings - Usando configuración personalizada');
    console.log('📄 JSON encontrado, longitud:', jsonStr.length + ' caracteres');
    
    try {
      const trimmed = jsonStr.trim();
      const jsonStrParsed = _lopSanitizeColorMapJsonString(jsonStr);
      if (jsonStrParsed !== trimmed) {
        console.warn('⚠️ LOP: lop_color_map_json tenía comas finales (o similar); se normalizó antes de parsear. Corregí el JSON en el tema para evitar depender de este parche.');
      }
      const parsedColorMap = JSON.parse(jsonStrParsed);
      if (parsedColorMap === null || typeof parsedColorMap !== 'object' || Array.isArray(parsedColorMap)) {
        throw new Error('El JSON debe ser un objeto { "Color": "#hex" }, no un array ni un valor suelto.');
      }
      const keyCount = Object.keys(parsedColorMap).length;
      console.log('✅ ColorMap cargado desde theme settings:', keyCount + ' colores');
      console.log('🎨 Colores disponibles:', Object.keys(parsedColorMap));
      
      // Verificar si tiene el color Negro con imagen como test
      if (parsedColorMap['Negro']) {
        console.log('🖼️ Color Negro detectado:', parsedColorMap['Negro']);
      }

      _setLopColorMapConfigMeta({
        themeJsonPresent: true,
        themeJsonLength: jsonStr.length,
        themeJsonParseOk: true,
        themeJsonParseError: null,
        activeMapSource: 'theme-json',
        mapKeyCount: keyCount,
        lopEnableColorSwatches: isEnabled,
        hint:
          'El JSON del tema se parseó bien. Si un color aparece como faltante, el texto en Shopify (opción Color del producto / data-color-name) no coincide con ninguna clave del JSON tras normalizar (mayúsculas y espacios se ignoran). Agregá una clave que coincida o renombrá la opción en el admin.'
      });
      
      return parsedColorMap;
    } catch (error) {
      console.error('❌ Error parseando colorMap JSON desde theme settings:', error);
      console.error('📄 JSON problemático:', colorMapJson);
      console.log('🔄 Fallback: Usando configuración hardcodeada');
      _setLopColorMapConfigMeta({
        themeJsonPresent: true,
        themeJsonLength: jsonStr.length,
        themeJsonParseOk: false,
        themeJsonParseError: error && error.message ? error.message : String(error),
        activeMapSource: 'pending-fallback',
        mapKeyCount: 0,
        lopEnableColorSwatches: isEnabled,
        hint:
          'El texto en "Configuración de Colores (JSON)" no es JSON válido o no es un objeto { ... }. Revisá: comas de más al final, comillas tipográficas (“”), comentarios // o /* */, texto fuera de llaves, o claves sin comillas. Corregí el JSON y guardá el tema; hasta entonces NO se usa tu lista (incluido TAUPE).'
      });
    }
  } else {
    _setLopColorMapConfigMeta({
      themeJsonPresent: !!colorMapJson,
      themeJsonLength: jsonStr.length,
      themeJsonParseOk: false,
      themeJsonParseError: null,
      activeMapSource: 'pending-fallback',
      mapKeyCount: 0,
      lopEnableColorSwatches: isEnabled,
      hint:
        'No hay JSON usable en theme settings (vacío o "{}"). El tema va a usar el mapa embebido (hardcoded o default), no lo que ves en el editor hasta que guardes un JSON válido.'
    });
  }
  
  // Solo si NO hay JSON válido, verificar si el sistema está habilitado
  if (!isEnabled) {
    console.log('🔍 Switch deshabilitado Y no hay JSON válido - Usando configuración hardcodeada');
    
    // HARDCODEAR tu configuración temporal hasta que se solucione el problema de settings
    const tuConfiguracion = {
      "Gris blanco": "#808080",
      "Verde Esmeralda": "#008060",
      "Marrón Claro": "#bfa06a",
      "Chocolate": "#805406",
      "Blanco Hueso": "#F9F6F6",
      "Gris verdoso": "#7d8c7c",
      "Gris Claro": "#b0b0b0",
      "Lila": "#c8a2c8",
      "Rosa": "#ffb6c1",
      "Rojo": "#ff0000",
      "Beige": "#f5f5dc",
      "Azul": "#0000ff",
      "Blanco": "#ffffff",
      "Blanco-Beige": "#F1ECEC",
      "Negro": "#000",
      "Marrón": "#9A5630",
      "Rosa Chicle": "#FC8CFA",
      "Negro-Marron": "#605E47",
      "Amarillo": "#FFE500",
      "Gris-Total": "#E1DDDD",
      "Lavanda-Claro": "#E5DAEC",
      "Gris-oscuro": "#A19F9F",
      "Bordo": "#A44B4B",
      "Lavanda": "#D9C5E9",
      "Beige-Marron": "#EFBC52",
      "aqua": "#00FFF0",
      "azul-francia": "#1503ba",
      "azul-gris": "#6699CC",
      "azul-oscuro": "#00008B",
      "azul-rojo": "#0000ff,#ff0000",
      "blanco-negro": "#FCF7F7,#000000",
      "caqui": "#F0E68C",
      "celeste": "#B2FFFF",
      "celeste-rosa": "#D4F1F4",
      "coral": "#FF7F50",
      "gris": "#746C70",
      "gris-azul": "#647C90",
      "gris-blanco": "#B0B7C0",
      "gris-claro": "#D3D3D3",
      "gris-glitter": "#C5C5C5",
      "gris-verdoso": "#6C6A61",
      "marron": "#964B00",
      "marron-claro": "#A47551",
      "rosa-bebe": "#FF92A5",
      "rosa-chicle": "#FF647F",
      "rosa-claro": "#FFC0CB",
      "rosa-pastel": "#F9B4F6",
      "verde": "#00A300",
      "verde-aguamarina": "#7FFFD4",
      "verde-esmeralda": "#50C878",
      "verde-militar": "#4B5320",
      "verde-oliva": "#636b2f",
      "violeta": "#4c2882",
      "Rosa,Rojo": "#ffb6c1,#ff0000",
      "Azul,Blanco": "#0000ff,#ffffff",
      "Negro-rojo": "#ff0000,#171717",
      "Negro,Rosa": "#000000,#ffb6c1",
      "Verde,Amarillo": "#00ff00,#ffff00",
      "Rojo,Blanco": "#ff0000,#ffffff",
      "Blanco,Negro": "#ffffff,#000000",
      "Multicolor": "#e41e26,#1474bb,#8fc33e",
      "Gris,Rojo": "#CDCDCD,#ff0000"
    };
    
    console.log('✅ Usando tu configuración personalizada con', Object.keys(tuConfiguracion).length, 'colores');
    console.log('🖼️ Color Negro con imagen detectado:', tuConfiguracion['Negro']);
    _setLopColorMapConfigMeta(
      Object.assign({}, window.lopColorMapConfigMeta || {}, {
        activeMapSource: 'fallback-hardcoded',
        mapKeyCount: Object.keys(tuConfiguracion).length,
        hint:
          (window.lopColorMapConfigMeta && window.lopColorMapConfigMeta.themeJsonParseError
            ? window.lopColorMapConfigMeta.hint
            : (window.lopColorMapConfigMeta && window.lopColorMapConfigMeta.hint) || '') +
          ' Mapa activo: lista embebida en app.js (hardcoded); no es el JSON del editor si ese JSON falló o está vacío.'
      })
    );
    return tuConfiguracion;
  }
  
  // Si llegamos aquí, no hay configuración válida en ningún lado
  console.log('🔄 No se encontró configuración válida, usando colorMap por defecto');
  const defaultMap = getDefaultColorMap();
  _setLopColorMapConfigMeta(
    Object.assign({}, window.lopColorMapConfigMeta || {}, {
      activeMapSource: 'fallback-default',
      mapKeyCount: Object.keys(defaultMap).length,
      hint:
        (window.lopColorMapConfigMeta && window.lopColorMapConfigMeta.themeJsonParseError
          ? window.lopColorMapConfigMeta.hint
          : (window.lopColorMapConfigMeta && window.lopColorMapConfigMeta.hint) || '') +
        ' Mapa activo: getDefaultColorMap() en app.js (switch LOP habilitado o sin hardcoded aplicable).'
    })
  );
  return defaultMap;
}

// FUNCIÓN para obtener colorMap por defecto (fallback)
function getDefaultColorMap() {
  return {
    // Colores existentes
    "Gris blanco": "#808080",
    "Verde Esmeralda": "#008060",
    "Marrón Claro": "#bfa06a",
    "Chocolate": "#805406",
    "Blanco Hueso": "#F9F6F6",
    "Gris verdoso": "#7d8c7c",
    "Gris Claro": "#b0b0b0",
    "Lila": "#c8a2c8",
    "Rosa": "#ffb6c1",
    "Rojo": "#ff0000",
    "Multicolor": "#ffcc00",
    "Beige": "#f5f5dc",
    "Azul": "#0000ff",
    "Blanco": "#fff",
    "Negro": "#000000",
    "Marrón": "#9A5630",
    "Rosa Chicle": "#FC8CFA",
    "Negro-Marron": "#605E47",
    "Amarillo": "#FFE500",
    "Gris-Total": "#E1DDDD",
    "Lavanda-Claro": "#E5DAEC",
    "Gris-oscuro": "#A19F9F",
    "Bordo": "#A44B4B",
    "Lavanda": "#D9C5E9",
    "Beige-Marron": "#EFBC52",
    "aqua": "#00FFF0",
    "azul-francia": "#1503ba",
    "azul-gris": "#6699CC",
    "azul-oscuro": "#00008B",
    "azul-rojo": "#0000ff,#ff0000",
    "blanco-negro": "#FCF7F7,#000000",
    "caqui": "#F0E68C",
    "celeste": "#B2FFFF",
    "celeste-rosa": "#D4F1F4",
    "coral": "#FF7F50",
    "gris": "#746C70",
    "gris-azul": "#647C90",
    "gris-blanco": "#B0B7C0",
    "gris-claro": "#D3D3D3",
    "gris-glitter": "#C5C5C5",
    "gris-verdoso": "#6C6A61",
    "marron": "#964B00",
    "marron-claro": "#A47551",
    "rosa-bebe": "#FF92A5",
    "rosa-chicle": "#FF647F",
    "rosa-claro": "#FFC0CB",
    "rosa-pastel": "#F9B4F6",
    "verde": "#00A300",
    "verde-aguamarina": "#7FFFD4",
    "verde-esmeralda": "#50C878",
    "verde-militar": "#4B5320",
    "verde-oliva": "#636b2f",
    "violeta": "#4c2882",
    // NUEVOS: Formato "color1,color2" para división vertical
    "Rosa,Rojo": "#ffb6c1,#ff0000",
    "Azul,Blanco": "#0000ff,#ffffff", 
    "Negro-rojo": "#ff0000,#171717", 
    "Negro,Rosa": "#000000,#ffb6c1",
    "Verde,Amarillo": "#00ff00,#ffff00",
    "Rojo,Blanco": "#ff0000,#ffffff",
    "Blanco,Negro": "#ffffff,#000000",
    "Multicolor": "#e41e26,#1474bb,#8fc33e",
    "Gris,Rojo": "#CDCDCD,#ff0000"
  };
}

// FUNCIÓN para obtener configuración de límites desde theme settings
function getColorLimitsFromSettings() {
  const defaultLimits = { desktop: 9, mobile: 6 };
  
  if (!window.Shopify || !window.Shopify.theme || !window.Shopify.theme.settings) {
    return defaultLimits;
  }
  
  const desktopLimit = window.Shopify.theme.settings.lop_max_colors_desktop || defaultLimits.desktop;
  const mobileLimit = window.Shopify.theme.settings.lop_max_colors_mobile || defaultLimits.mobile;
  
  return {
    desktop: parseInt(desktopLimit),
    mobile: parseInt(mobileLimit)
  };
}

// FUNCIÓN para determinar si usar el colorMap por defecto
function shouldUseDefaultColorMap() {
  // Verificar si hay configuración de Shopify disponible
  if (!window.Shopify || !window.Shopify.theme || !window.Shopify.theme.settings) {
    console.log('🔄 Usando colorMap por defecto: No hay configuración de Shopify disponible');
    return true;
  }
  
  const settings = window.Shopify.theme.settings;
  const isEnabled = settings.lop_enable_color_swatches;
  const colorMapJson = settings.lop_color_map_json;
  
  console.log('🔍 Evaluando configuración:', {
    isEnabled: isEnabled,
    hasColorMapJson: !!colorMapJson,
    jsonLength: colorMapJson ? colorMapJson.length : 0
  });
  
  // Si el switch está explícitamente deshabilitado (false), usar colorMap por defecto
  if (isEnabled === false) {
    console.log('🔄 Usando colorMap por defecto: Switch explícitamente deshabilitado');
    return true;
  }
  
  // Si el switch está habilitado (true) pero no hay JSON válido, usar colorMap por defecto
  if (isEnabled === true && (!colorMapJson || colorMapJson.trim() === '' || colorMapJson.trim() === '{}')) {
    console.log('🔄 Usando colorMap por defecto: Switch habilitado pero JSON vacío o inválido');
    return true;
  }
  
  // Si llegamos aquí, significa que hay configuración válida - usar settings
  if (isEnabled === true && colorMapJson && colorMapJson.trim() !== '') {
    console.log('✅ Usando configuración de theme settings: Switch habilitado y JSON presente');
    return false;
  }
  
  // Fallback: si isEnabled es undefined/null pero hay JSON, intentar usarlo
  if (colorMapJson && colorMapJson.trim() !== '' && colorMapJson.trim() !== '{}') {
    console.log('⚠️ Switch indefinido pero JSON presente - intentando usar settings');
    return false;
  }
  
  // Por defecto, usar colorMap por defecto
  console.log('🔄 Usando colorMap por defecto: No se cumplieron condiciones para usar settings');
  return true;
}

// NUEVA LÓGICA SIMPLIFICADA: Siempre intentar cargar desde settings primero
let colorMap;
console.log('🚀 Iniciando carga de colorMap...');

// Intentar cargar desde theme settings sin importar el estado del switch
const themeSettingsColorMap = loadColorMapFromSettings();

// Si se cargó algo válido, usarlo
if (themeSettingsColorMap && Object.keys(themeSettingsColorMap).length > 0) {
  colorMap = themeSettingsColorMap;
  console.log('✅ Usando colorMap desde theme settings con', Object.keys(colorMap).length, 'colores');
} else {
  colorMap = getDefaultColorMap();
  console.log('🎨 Fallback: Usando colorMap por defecto con', Object.keys(colorMap).length, 'colores');
  _setLopColorMapConfigMeta(
    Object.assign({}, window.lopColorMapConfigMeta || {}, {
      activeMapSource: 'fallback-default',
      mapKeyCount: Object.keys(colorMap).length
    })
  );
}

// Límites de colores desde settings
let colorLimits = getColorLimitsFromSettings();

// ColorMap original mantenido como referencia/fallback
const originalColorMap = {
  // Colores existentes
  "Gris blanco": "#808080",
  "Verde Esmeralda": "#008060",
  "Marrón Claro": "#bfa06a",
  "Chocolate": "#805406",
  "Blanco Hueso": "#F9F6F6",
  "Gris verdoso": "#7d8c7c",
  "Gris Claro": "#b0b0b0",
  "Lila": "#c8a2c8",
  "Rosa": "#ffb6c1",
  "Rojo": "#ff0000",
  "Multicolor": "#ffcc00",
  "Beige": "#f5f5dc",
  "Azul": "#0000ff",
  "Blanco": "#ffffff",
  "Blanco": "#FCF7F7",
  "Blanco-Beige": "#F1ECEC",
  "Negro": "#000",
  "Marrón": "#9A5630",
  "Rosa Chicle": "#FC8CFA",
  "Negro-Marron": "#605E47",
  "Amarillo": "#FFE500",
  "Gris-Total": "#E1DDDD",
  "Lavanda-Claro": "#E5DAEC",
  "Gris-oscuro": "#A19F9F",
  "Bordo": "#A44B4B",
  "Lavanda": "#D9C5E9",
  "Beige-Marron": "#EFBC52",
  "aqua": "#00FFF0",
  "azul-francia": "#1503ba",
  "azul-gris": "#6699CC",
  "azul-oscuro": "#00008B",
  "azul-rojo": "#0000ff,",
  "blanco-negro": "#FCF7F7,",
  "caqui": "#F0E68C",
  "celeste": "#B2FFFF",
  "celeste-rosa": "#D4F1F4",
  "coral": "#FF7F50",
  "gris": "#746C70",
  "gris-azul": "#647C90",
  "gris-blanco": "#B0B7C0",
  "gris-claro": "#D3D3D3",
  "gris-glitter": "#C5C5C5",
  "gris-verdoso": "#6C6A61",
  "marron": "#964B00",
  "marron-claro": "#A47551",
  "rosa-bebe": "#FF92A5",
  "rosa-chicle": "#FF647F",
  "rosa-claro": "#FFC0CB",
  "rosa-pastel": "#F9B4F6",
  "verde": "#00A300",
  "verde-aguamarina": "#7FFFD4",
  "verde-esmeralda": "#50C878",
  "verde-militar": "#4B5320",
  "verde-oliva": "#636b2f",
  "violeta": "#4c2882",
  // NUEVOS: Formato "color1,color2" para división vertical
  "Rosa,Rojo": "#ffb6c1,#ff0000",
  "Azul,Blanco": "#0000ff,#ffffff", 
  "Negro-rojo": "#ff0000,#171717", 
  "Negro,Rosa": "#000000,#ffb6c1",
  "Verde,Amarillo": "#00ff00,#ffff00",
  "Rojo,Blanco": "#ff0000,#ffffff",
  "Blanco,Negro": "#ffffff,#000000",
  "Multicolor": "#e41e26,#1474bb,#8fc33e",
  "Gris,Rojo": "#CDCDCD,#ff0000",
  
  // NUEVOS: Soporte para imágenes
  // Formato: "Color con imagen": "image:URL_DE_LA_IMAGEN"
  //"Negro": "image:https://cdn.shopify.com/s/files/1/0937/6150/3518/files/z.jpg?v=1754967581",
  
  // NUEVOS: Soporte para imágenes
  // Formato: "Color con imagen": "image:URL_DE_LA_IMAGEN"
  //"Negro": "image:https://cdn.shopify.com/s/files/1/0937/6150/3518/files/z.jpg?v=1754967581",

};

// FUNCIÓN para recargar configuración (útil para desarrollo/debugging)
function reloadColorConfiguration() {
  console.log('🔄 Recargando configuración de colores...');
  colorMap = loadColorMapFromSettings();
  _colorMapNorm = null;
  colorLimits = getColorLimitsFromSettings();
  console.log('✅ Configuración recargada:', {
    colores: Object.keys(colorMap).length,
    limitesDesktop: colorLimits.desktop,
    limitesMobile: colorLimits.mobile
  });
  // Hacer la función global para debugging
  window.lopReloadColors = reloadColorConfiguration;
}

// Normaliza un nombre de color: trim, lowercase, espacios → guión, colapsa guiones repetidos
function _normColorKey(name) {
  if (name == null) return '';
  return String(name)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/\-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Lookup tolerante en colorMap: case-insensitive + whitespace-insensitive
let _colorMapNorm = null;
function getColorMapValue(colorName) {
  if (!colorName) return undefined;
  if (colorMap[colorName] !== undefined) return colorMap[colorName];
  if (!_colorMapNorm) {
    _colorMapNorm = {};
    Object.keys(colorMap).forEach(function(k) { _colorMapNorm[_normColorKey(k)] = colorMap[k]; });
  }
  return _colorMapNorm[_normColorKey(colorName)];
}

// FUNCIÓN HELPER - Para validar formato de colores
function isValidColorFormat(colorName) {
  // Verificar si es formato "color1,color2" o "color1,color2,color3"
  if (colorName.includes(',')) {
    const parts = colorName.split(',');
    return (parts.length === 2 || parts.length === 3) && 
           parts.every(part => part.trim());
  }
  // Si no tiene coma, verificar si existe en el colorMap
  return colorMap[colorName] !== undefined;
}

// FUNCIÓN HELPER - Para detectar si un valor es una imagen
function isImageValue(value) {
  return value && value.startsWith('image:');
}

// FUNCIÓN HELPER - Para extraer URL de la imagen
function extractImageUrl(value) {
  return value.replace('image:', '');
}

// FUNCIÓN HELPER - Para detectar si un color tiene múltiples valores (colores divididos o imagen)
function isComplexColor(colorValue) {
  return colorValue && (colorValue.includes(',') || colorValue.startsWith('image:'));
}

// FUNCIÓN MEJORADA para crear swatches con colores divididos
function createSwatch(colorName, handle, currentHandle, swatchIndex = 0, totalColors = 0) {
  const swatch = document.createElement('span');
  swatch.className = 'product-card-swatch swatch-item';
  swatch.title = colorName;
  swatch.style.cursor = 'pointer';
  swatch.style.display = 'inline-flex';
  swatch.style.alignItems = 'center';
  swatch.style.justifyContent = 'center';
  swatch.style.margin = '0';
  swatch.style.padding = '0';
  swatch.style.position = 'relative';
  swatch.style.overflow = 'hidden';
  
  // LÓGICA LOP: Aplicar clases de visibilidad según cantidad de colores (configurables desde theme settings)
  if (totalColors > colorLimits.desktop && swatchIndex >= colorLimits.desktop) {
    swatch.classList.add('swatch-hidden-desktop');
  }
  if (totalColors > colorLimits.mobile && swatchIndex >= colorLimits.mobile) {
    swatch.classList.add('swatch-hidden-mobile');
  }
  
  const colorValue = getColorMapValue(colorName);
  
  if (!colorValue) {
    swatch.style.background = '#cccccc';
  } else if (isImageValue(colorValue)) {
    // NUEVA LÓGICA: Procesar imagen
    const imageUrl = extractImageUrl(colorValue);
    console.log('Aplicando imagen:', imageUrl);
    
    // Configurar el swatch como contenedor de imagen
    swatch.style.background = `url("${imageUrl}") center center / cover no-repeat`;
    swatch.style.border = '2px solid #ddd';
    swatch.style.borderRadius = '50%';
    
    // Agregar clase específica para swatches con imagen
    swatch.classList.add('swatch-with-image');
    
  } else if (colorValue.includes(',')) {
    // AQUÍ ES DONDE SE PROCESA EL FORMATO "color1,color2" o "color1,color2,color3"
    const colors = colorValue.split(',');
    console.log('Colores encontrados:', colors.length, colors);
    
    if (colors.length === 2) {
      // División vertical: mitad izquierda color1, mitad derecha color2
      swatch.style.background = `linear-gradient(90deg, ${colors[0]} 50%, ${colors[1]} 50%)`;
      console.log('Aplicando 2 colores:', colors[0], colors[1]);
    } else if (colors.length === 3) {
      // División en tres partes: 33.33% cada color
      swatch.style.background = `linear-gradient(90deg, ${colors[0]} 0%, ${colors[0]} 33.33%, ${colors[1]} 33.33%, ${colors[1]} 66.66%, ${colors[2]} 66.66%, ${colors[2]} 100%)`;
      console.log('Aplicando 3 colores:', colors[0], colors[1], colors[2]);
    }
  } else {
    // Color sólido normal
    swatch.style.background = colorValue;
  }
  
  // Marcar como actual si corresponde
  if (handle === currentHandle) {
    swatch.style.border = '0px solid #000';
    swatch.style.transform = 'scale(1.1)';
  }
  
  // Eventos
  swatch.setAttribute('data-handle', handle);
  swatch.setAttribute('data-color', colorName);
  
  swatch.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const targetHandle = this.getAttribute('data-handle');
    if (targetHandle && targetHandle !== currentHandle) {
      window.location.href = `/products/${targetHandle}`;
    }
  });
  
  // Efectos hover
  swatch.addEventListener('mouseenter', function() {
    if (this.getAttribute('data-handle') !== currentHandle) {
      this.style.transform = 'scale(1.2)';
      this.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
      this.style.zIndex = '20';
    }
  });
  
  swatch.addEventListener('mouseleave', function() {
    if (this.getAttribute('data-handle') !== currentHandle) {
      this.style.transform = 'scale(1)';
      this.style.boxShadow = 'none';
      this.style.zIndex = '10';
    }
  });
  
  return swatch;
}

// FUNCIÓN LOP para convertir un swatch en indicador de más colores
function convertSwatchToMoreIndicator(swatch, remainingCount) {
  // Limpiar contenido anterior
  swatch.innerHTML = '';
  
  // Cambiar estilos para mostrar el indicador
  swatch.style.backgroundColor = '#f5f5f5';
  swatch.style.border = '1px solid #ddd';
  swatch.style.color = '#666';
  swatch.style.fontSize = '8px';
  swatch.style.fontWeight = 'bold';
  swatch.style.cursor = 'default';
  swatch.style.pointerEvents = 'none';
  swatch.style.background = '#f5f5f5'; // Sobrescribir background del color original
  
  // Mostrar el número de colores restantes
  swatch.innerHTML = `+${remainingCount}`;
  swatch.title = `Hay ${remainingCount} colores más disponibles`;
  
  // Agregar clase identificadora
  swatch.classList.add('LOP-more-colors-indicator');
  
  return swatch;
}

// VERSIÓN AUTOMÁTICA - Si quieres que funcione sin agregar al colorMap
function createSwatchAuto(colorName, handle, currentHandle) {
  const swatch = document.createElement('span');
  swatch.className = 'product-card-swatch swatch-item';
  swatch.title = colorName;
  swatch.style.cursor = 'pointer';
  swatch.style.display = 'inline-flex';
  swatch.style.alignItems = 'center';
  swatch.style.justifyContent = 'center';
  swatch.style.margin = '0';
  swatch.style.padding = '0';
  swatch.style.position = 'relative';
  swatch.style.overflow = 'hidden';
  
  // LÓGICA AUTOMÁTICA PARA DETECTAR FORMATO
  const colorValue = colorMap[colorName];
  
  if (!colorValue) {
    // Color no encontrado
    swatch.style.background = '#cccccc';
  } else if (isImageValue(colorValue)) {
    // NUEVA LÓGICA: Procesar imagen
    const imageUrl = extractImageUrl(colorValue);
    console.log('Aplicando imagen (auto):', imageUrl);
    
    // Configurar el swatch como contenedor de imagen
    swatch.style.background = `url("${imageUrl}") center center / cover no-repeat`;
    swatch.style.border = '2px solid #ddd';
    swatch.style.borderRadius = '50%';
    
    // Agregar clase específica para swatches con imagen
    swatch.classList.add('swatch-with-image');
    
  } else if (colorName.includes(',')) {
    // Formato "color1,color2" o "color1,color2,color3"
    const colorNames = colorName.split(',').map(c => c.trim());
    
    if (colorNames.length === 2) {
      const color1 = colorMap[colorNames[0]] || '#cccccc'; // fallback gris
      const color2 = colorMap[colorNames[1]] || '#cccccc'; // fallback gris
      // División vertical
      swatch.style.background = `linear-gradient(90deg, ${color1} 50%, ${color2} 50%)`;
    } else if (colorNames.length === 3) {
      const color1 = colorMap[colorNames[0]] || '#cccccc'; // fallback gris
      const color2 = colorMap[colorNames[1]] || '#cccccc'; // fallback gris
      const color3 = colorMap[colorNames[2]] || '#cccccc'; // fallback gris
      // División en tres partes
      swatch.style.background = `linear-gradient(90deg, ${color1} 0%, ${color1} 33.33%, ${color2} 33.33%, ${color2} 66.66%, ${color3} 66.66%, ${color3} 100%)`;
    }
  } else if (colorValue) {
    // Color simple del mapa
    swatch.style.background = colorValue;
  } else {
    // Fallback final
    swatch.style.background = '#cccccc';
  }
  
  // Marcar como actual si corresponde
  if (handle === currentHandle) {
    swatch.style.border = '0px solid #000';
    swatch.style.transform = 'scale(1.1)';
  }
  
  swatch.setAttribute('data-handle', handle);
  swatch.setAttribute('data-color', colorName);
  
  swatch.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const targetHandle = this.getAttribute('data-handle');
    if (targetHandle && targetHandle !== currentHandle) {
      window.location.href = `/products/${targetHandle}`;
    }
  });
  
  swatch.addEventListener('mouseenter', function() {
    if (this.getAttribute('data-handle') !== currentHandle) {
      this.style.transform = 'scale(1.2)';
      this.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
      this.style.zIndex = '20';
    }
  });
  
  swatch.addEventListener('mouseleave', function() {
    if (this.getAttribute('data-handle') !== currentHandle) {
      this.style.transform = 'scale(1)';
      this.style.boxShadow = 'none';
      this.style.zIndex = '10';
    }
  });
  
  return swatch;
}

document.addEventListener("DOMContentLoaded", function() {
  const swatchDivs = document.querySelectorAll('.product-card-swatches[data-product-handle]');
  const agrupadorMap = {};

  // FUNCIÓN PARA DETECTAR SI HAY PRODUCTOS EN LA PÁGINA
  function hasProducts() {
    return document.querySelectorAll('.product-card').length > 0;
  }

  /**
   * Tarjeta “estable” para el intervalo de reintento:
   * - Rango personalizado o bloque descuento LOP, y/o
   * - Cuotas ya inyectadas (.lop-installments-container) cuando el módulo está activo.
   * En home / collection tabs muchas tarjetas solo tienen precio Shopify + cuotas (sin JSON de agrupador);
   * antes el intervalo las veía siempre “pendientes” y reprocesaba en bucle (swatches + cuotas).
   */
  function productCardHasLopPricing(card) {
    if (!card || typeof card.querySelector !== 'function') return false;
    if (card.querySelector('.precio-personalizado-container') || card.querySelector('.LOP-precios-descuento-container')) {
      return true;
    }
    const body = document.body;
    if (body && body.getAttribute('data-lop-enable-installments') === 'true') {
      if (card.querySelector('.lop-installments-container')) return true;
    }
    return false;
  }

  function countProductCardsPendingLopPricing() {
    const cards = document.querySelectorAll('.product-card');
    let pending = 0;
    cards.forEach(function (card) {
      if (!productCardHasLopPricing(card)) pending++;
    });
    return { total: cards.length, pending: pending };
  }

  // FUNCIÓN PARA VERIFICAR SI HAY DATOS NECESARIOS
  function hasRequiredData() {
    const globalJson = document.getElementById('agrupadores-precios-json-global');
    const swatchDivs = document.querySelectorAll('.product-card-swatches[data-product-handle]');
    
    console.log('Verificando datos necesarios:');
    console.log('- JSON global:', globalJson ? 'Disponible' : 'No disponible');
    console.log('- Swatches con datos:', swatchDivs.length);
    
    return globalJson && swatchDivs.length > 0;
  }

  // FUNCIÓN para agregar cuotas a todos los productos que no las tengan
  function agregarCuotasATodosLosProductos() {
    const body = document.body;
    const enableInstallments = body.getAttribute('data-lop-enable-installments');
    
    if (enableInstallments !== 'true') {
      return;
    }
    
    let installmentsCount = 6;
    let bgColor = '#000';
    let textColor = '#fff';
    
    const countFromBody = body.getAttribute('data-lop-installments-count');
    const bgFromBody = body.getAttribute('data-lop-installments-bg-color');
    const textFromBody = body.getAttribute('data-lop-installments-text-color');
    
    if (countFromBody) installmentsCount = parseInt(countFromBody) || 6;
    if (bgFromBody) bgColor = bgFromBody;
    if (textFromBody) textColor = textFromBody;
    
    // Buscar todos los productos
    const allCards = document.querySelectorAll('.product-card');
    let cuotasAgregadas = 0;
    
    allCards.forEach(card => {
      const infoInner = card.querySelector('.product-card-info--inner');
      if (!infoInner) return;
      
      // Siempre eliminar cuotas existentes para reubicarlas al final
      const existingInstallments = infoInner.querySelector('.lop-installments-container');
      if (existingInstallments) {
        existingInstallments.remove();
      }
      
      // Precio base cuotas: verde LOP (post desc. colección) → oferta Shopify (ins) → precio-minimo → data-product-price.
      // Antes: data-product-price primero podía ser lista/compare en algunos contextos → cuotas = tachado/6.
      const precioBase = lopObtenerPrecioBaseCuotasProductCard(card);
      
      if (precioBase && precioBase > 0) {
        const installmentAmount = Math.round(precioBase / installmentsCount);
        const installmentAmountStr = formatearPrecio(installmentAmount);
        
        const installmentsHtml = `<div class="lop-installments-container" style="background-color: ${bgColor}; color: ${textColor};"><span>${installmentsCount} cuotas de $${installmentAmountStr} sin interes</span></div>`;
        
        // SIEMPRE insertar al final del infoInner para garantizar posición consistente
        infoInner.insertAdjacentHTML('beforeend', installmentsHtml);
        
        cuotasAgregadas++;
      }
    });
    
    if (cuotasAgregadas > 0) {
      console.log(`✅ Cuotas agregadas/reubicadas en ${cuotasAgregadas} productos`);
    }
  }

  // FUNCIÓN MEJORADA para procesar precios con fallback
  function procesarPreciosProductos() {
    // Solo procesar si hay productos
    if (!hasProducts()) {
      console.log('No hay productos en la página, saltando procesamiento');
      return;
    }

    // IMPORTANTE: Buscar swatches incluyendo los que están en slides ocultos
    // Usar un selector más amplio que incluya carruseles y elementos ocultos
    const swatchDivs = document.querySelectorAll('.product-card-swatches[data-product-handle], .carousel__slide .product-card-swatches[data-product-handle], .products.carousel .product-card-swatches[data-product-handle]');
    
    // Si no hay swatches directos, buscar en todos los product-cards y verificar si necesitan swatches
    let allSwatchContainers = Array.from(swatchDivs);
    
    // También buscar en productos que puedan no tener swatches renderizados aún
    const allProductCards = document.querySelectorAll('.product-card, .carousel__slide .product-card, .featured-collection__inner .product-card');
    console.log(`Encontrados ${allProductCards.length} product-cards en total`);
    
    allProductCards.forEach(card => {
      const swatchContainer = card.querySelector('.product-card-swatches[data-product-handle]');
      if (swatchContainer && !allSwatchContainers.includes(swatchContainer)) {
        allSwatchContainers.push(swatchContainer);
      }
    });
    
    if (allSwatchContainers.length === 0) {
      console.log('No hay swatches para procesar');
      return;
    }
    
    // Limpiar el mapa de agrupadores para evitar duplicados
    Object.keys(agrupadorMap).forEach(key => delete agrupadorMap[key]);
    
    console.log(`Procesando ${allSwatchContainers.length} swatches (incluyendo carruseles)...`);
    
    allSwatchContainers.forEach((div, index) => {
      const agrupador = div.getAttribute('data-agrupador');
      const colorName = div.getAttribute('data-color-name');
      const handle = div.getAttribute('data-product-handle');
      const imageUrl = div.getAttribute('data-image') || '';
      
      console.log(`Swatch ${index + 1}:`, { agrupador, colorName, handle, imageUrl: imageUrl ? 'sí' : 'no', visible: div.offsetParent !== null });
      
      if (!agrupadorMap[agrupador]) agrupadorMap[agrupador] = [];
      agrupadorMap[agrupador].push({ colorName, handle, imageUrl });
    });

    console.log('Agrupadores encontrados:', Object.keys(agrupadorMap));

    allSwatchContainers.forEach((div, index) => {
      const agrupador = div.getAttribute('data-agrupador');
      const grupo = agrupadorMap[agrupador] || [];
      const coloresMostrados = new Set();
      div.innerHTML = "";

      // Precalcular colores unicos validos (case-insensitive dedup)
      const coloresUnicosValidos = new Set();
      grupo.forEach(prod => {
        const norm = (prod.colorName || '').toLowerCase();
        if (getColorMapValue(prod.colorName) && !coloresUnicosValidos.has(norm)) {
          coloresUnicosValidos.add(norm);
        }
      });
      const totalColoresValidos = coloresUnicosValidos.size;

      const swatchesCreados = [];

      grupo.forEach(prod => {
        const normColor = (prod.colorName || '').toLowerCase();
        if (getColorMapValue(prod.colorName) && !coloresMostrados.has(normColor)) {
          const currentHandle = div.getAttribute('data-product-handle');
          const swatchIndex = coloresMostrados.size;
          const swatch = createSwatch(prod.colorName, prod.handle, currentHandle, swatchIndex, totalColoresValidos);
          div.appendChild(swatch);
          swatchesCreados.push(swatch);
          coloresMostrados.add(normColor);
        }
      });

      const numPintados = swatchesCreados.length;

      // LOG: colores del grupo que NO tienen entrada en colorMap (nombre original)
      const coloresSinMapNorm = new Set();
      const coloresSinMapOriginal = [];
      grupo.forEach(prod => {
        const norm = (prod.colorName || '').toLowerCase();
        if (!getColorMapValue(prod.colorName) && !coloresSinMapNorm.has(norm)) {
          coloresSinMapNorm.add(norm);
          coloresSinMapOriginal.push(prod.colorName);
        }
      });
      if (coloresSinMapOriginal.length > 0) {
        console.warn(
          `%c[LOP FALTANTES] Agrupador "${agrupador}" — ${coloresSinMapOriginal.length} color(es) SIN entrada en colorMap:`,
          'background: #ff6b00; color: white; padding: 2px 6px; border-radius: 3px;',
          coloresSinMapOriginal
        );
        const cfg = window.lopColorMapConfigMeta;
        if (cfg) {
          console.warn(
            '%c[LOP CONFIG] Estado del mapa de colores (theme settings / JSON)',
            'background: #6c3483; color: white; padding: 2px 6px; border-radius: 3px;',
            {
              activeMapSource: cfg.activeMapSource,
              themeJsonPresent: cfg.themeJsonPresent,
              themeJsonLength: cfg.themeJsonLength,
              themeJsonParseOk: cfg.themeJsonParseOk,
              themeJsonParseError: cfg.themeJsonParseError,
              mapKeyCount: cfg.mapKeyCount,
              lopEnableColorSwatches: cfg.lopEnableColorSwatches,
              hint: cfg.hint
            }
          );
          if (cfg.themeJsonParseError) {
            console.warn(
              '%c[LOP CONFIG] ⚠️ El JSON del tema no es válido: no se aplica lo del editor hasta corregirlo.',
              'background: #c0392b; color: white; padding: 2px 6px; border-radius: 3px;',
              'Mensaje:',
              cfg.themeJsonParseError
            );
          } else if (cfg.themeJsonParseOk && cfg.activeMapSource === 'theme-json') {
            console.warn(
              '%c[LOP CONFIG] El JSON del tema cargó bien: el faltante suele ser el nombre en Shopify (opción Color) vs la clave del JSON.',
              'background: #1e8449; color: white; padding: 2px 6px; border-radius: 3px;'
            );
          }
        } else {
          console.warn('[LOP CONFIG] Sin metadatos (lopColorMapConfigMeta). Revisá la carga de app.js / theme.liquid.');
        }
        const sugerencias = coloresSinMapOriginal.map(function (nombre) {
          return { nombreEnProducto: nombre, claveNormalizada: _normColorKey(nombre) };
        });
        console.warn('[LOP CONFIG] Compará `claveNormalizada` con las claves del JSON (el código hace match sin importar mayúsculas/espacios extra):', sugerencias);
      }

      // LOP "+N": solo cuando se excede el limite del personalizador
      if (numPintados > colorLimits.desktop) {
        const lastSwatchDesktop = swatchesCreados[colorLimits.desktop - 1];
        const remainingDesktop = numPintados - colorLimits.desktop;
        convertSwatchToMoreIndicator(lastSwatchDesktop, remainingDesktop);
        lastSwatchDesktop.classList.add('LOP-indicator-desktop-only');

        for (let i = colorLimits.desktop; i < numPintados; i++) {
          swatchesCreados[i].classList.add('swatch-hidden-desktop');
        }
      }

      if (numPintados > colorLimits.mobile) {
        const lastSwatchMobile = swatchesCreados[colorLimits.mobile - 1];
        const remainingMobile = numPintados - colorLimits.mobile;

        const mobileIndicator = lastSwatchMobile.cloneNode(true);
        convertSwatchToMoreIndicator(mobileIndicator, remainingMobile);
        mobileIndicator.className = 'product-card-swatch LOP-more-colors-indicator LOP-indicator-mobile-only';
        lastSwatchMobile.parentNode.insertBefore(mobileIndicator, lastSwatchMobile.nextSibling);

        lastSwatchMobile.classList.add('swatch-hidden-mobile');
        for (let i = colorLimits.mobile; i < numPintados; i++) {
          swatchesCreados[i].classList.add('swatch-hidden-mobile');
        }
      }

      // NUEVO: Mostrar precios mínimo y máximo usando el JSON global, con formato visual como la primera imagen
      const globalJson = document.getElementById('agrupadores-precios-json-global');
      if (globalJson && agrupador) {
        try {
          const agrupadores = JSON.parse(globalJson.textContent);
          const precios = agrupadores[agrupador] || [];
          const preciosSolo = precios.map(p => p.price);
          
          console.log(`Agrupador "${agrupador}":`, { precios: preciosSolo.length, valores: preciosSolo });
          
          if (preciosSolo.length > 0) {
            const min = Math.min(...preciosSolo);
            const max = Math.max(...preciosSolo);
            // Busca el contenedor donde van los precios
            const card = div.closest('.product-card');
            if (card) {
              // PRIMERO: Verificar si ya existen precios personalizados para evitar duplicados
              const existingCustomPrice = card.querySelector('.precio-personalizado-container');
              if (existingCustomPrice) {
                existingCustomPrice.remove(); // Remover precio personalizado anterior
              }
              
              // Un solo precio en el agrupador: dejar el .price de Liquid (compare_at + oferta) o el que aplique LOP;
              // inyectar .precio-personalizado-container pisa la vista y, por CSS, oculta .price.
              let priceHtml = '';
              if (max !== min) {
                priceHtml = `<div class="precio-personalizado-container"><span class='precio-maximo' style='color: #368617; font-size: 18px; font-weight: bold;'>$${formatearPrecio(max)}</span> <span style='font-size: 18px;'>a</span> <span class='precio-minimo' style='color: #222; font-size: 18px; font-weight: 500;'>$${formatearPrecio(min)}</span></div>`;
              }
              
              // Busca el contenedor de precios (ajusta si es necesario)
              const infoInner = card.querySelector('.product-card-info--inner');
              if (infoInner) {
                if (priceHtml) {
                  const swatchContainer = infoInner.querySelector('.product-card-swatches--container');
                  if (swatchContainer) {
                    swatchContainer.insertAdjacentHTML('afterend', priceHtml);
                  } else {
                    const title = infoInner.querySelector('.product-card-title');
                    if (title) {
                      title.insertAdjacentHTML('afterend', priceHtml);
                    } else {
                      infoInner.insertAdjacentHTML('beforeend', priceHtml);
                    }
                  }
                }
                
                // Impuestos nacionales + cuotas: solo inyectar si hay RANGO (min < max) y el .price
                // de Liquid queda tapado por .precio-personalizado. Si min = max, product-price-without-taxes.liquid
                // ya deja "Precio sin impuestos" + lop-interest-free-installments: duplicar aquí + forzarPrecioBasico
                // generaba 2–3 líneas idénticas en productos sin descuento.
                if (max !== min && precios.length > 0) {
                  const referencia = precios[0];
                  let impuesto = 21;
                  if (referencia.lop_impuestos_nacionales !== undefined && referencia.lop_impuestos_nacionales !== null && referencia.lop_impuestos_nacionales !== "") {
                    impuesto = parseFloat(referencia.lop_impuestos_nacionales);
                    if (isNaN(impuesto) || impuesto === 0) impuesto = 21;
                  }
                  const divisor = 1 + (impuesto / 100);
                  const minSinImpuesto = Math.round((min / divisor));
                  const minSinImpuestoStr = formatearPrecio(minSinImpuesto);
                  const textoPrecioSinImpuestos = obtenerTextoPrecioSinImpuestos(minSinImpuestoStr);
                  const priceNoTaxHtml = `<div class="product-price-without-taxes-personalizado"><small>${textoPrecioSinImpuestos}</small></div>`;
                  
                  infoInner.querySelectorAll('.product-price-without-taxes-personalizado').forEach((el) => el.remove());
                  infoInner.insertAdjacentHTML('beforeend', priceNoTaxHtml);
                  
                  const body = document.body;
                  if (body) {
                    const enableInstallments = body.getAttribute('data-lop-enable-installments');
                    
                    if (enableInstallments === 'true') {
                      let installmentsCount = 9;
                      let bgColor = '#FFE5E5';
                      let textColor = '#222222';
                      
                      const countFromBody = body.getAttribute('data-lop-installments-count');
                      const bgFromBody = body.getAttribute('data-lop-installments-bg-color');
                      const textFromBody = body.getAttribute('data-lop-installments-text-color');
                      
                      if (countFromBody) installmentsCount = parseInt(countFromBody) || 9;
                      if (bgFromBody) bgColor = bgFromBody;
                      if (textFromBody) textColor = textFromBody;
                      
                      let precioBaseCuotas = min;
                      
                      const precioDescuentoElement = card.querySelector('.LOP-precio-descuento');
                      if (precioDescuentoElement) {
                        const precioDescuentoText = precioDescuentoElement.textContent.replace(/[^\d]/g, '');
                        if (precioDescuentoText) {
                          const parsed = parseInt(precioDescuentoText, 10);
                          if (parsed > 0) precioBaseCuotas = parsed;
                        }
                      }
                      
                      const installmentAmount = Math.round(precioBaseCuotas / installmentsCount);
                      const installmentAmountStr = formatearPrecio(installmentAmount);
                      
                      const installmentsHtml = `<div class="lop-installments-container" style="background-color: ${bgColor}; color: ${textColor};"><span>${installmentsCount} cuotas de $${installmentAmountStr} sin interes</span></div>`;
                      
                      const prevInstallments = infoInner.querySelector('.lop-installments-container');
                      if (prevInstallments) prevInstallments.remove();
                      
                      infoInner.insertAdjacentHTML('beforeend', installmentsHtml);
                    }
                  }
                }
                // --- FIN bloque rango (min < max) ---
              }
            }
          } else {
            console.log(`No hay precios para el agrupador "${agrupador}" - usando precios por defecto`);
            // FALLBACK: Si no hay precios personalizados, asegurar que se muestren los precios por defecto
            const card = div.closest('.product-card');
            if (card) {
              // Remover cualquier precio personalizado que pueda estar ocultando los precios por defecto
              const existingCustomPrice = card.querySelector('.precio-personalizado-container');
              if (existingCustomPrice) {
                existingCustomPrice.remove();
              }
              
              const existingCustomNoTax = card.querySelector('.product-price-without-taxes-personalizado');
              if (existingCustomNoTax) {
                existingCustomNoTax.remove();
              }
              
              // Asegurar que los precios por defecto sean visibles
              const defaultPrices = card.querySelectorAll('.price, .product-price-without-taxes');
              defaultPrices.forEach(price => {
                price.style.display = 'block';
                price.style.visibility = 'visible';
                price.style.opacity = '1';
                price.style.position = 'static';
                price.style.clip = 'auto';
                price.style.height = 'auto';
                price.style.width = 'auto';
                price.style.margin = '';
                price.style.padding = '';
                price.style.overflow = 'visible';
              });
              
              // AGREGAR CUOTAS PARA PRECIOS POR DEFECTO
              const body = document.body;
              const enableInstallments = body.getAttribute('data-lop-enable-installments');
              
              if (enableInstallments === 'true') {
                const infoInner = card.querySelector('.product-card-info--inner');
                if (infoInner) {
                  // Obtener precio del producto desde data attribute (ya viene en pesos)
                  const productPrice = card.getAttribute('data-product-price');
                  if (productPrice) {
                    const precioBase = parseInt(productPrice); // Ya está en pesos
                    
                    let installmentsCount = 6;
                    let bgColor = '#000';
                    let textColor = '#fff';
                    
                    const countFromBody = body.getAttribute('data-lop-installments-count');
                    const bgFromBody = body.getAttribute('data-lop-installments-bg-color');
                    const textFromBody = body.getAttribute('data-lop-installments-text-color');
                    
                    if (countFromBody) installmentsCount = parseInt(countFromBody) || 6;
                    if (bgFromBody) bgColor = bgFromBody;
                    if (textFromBody) textColor = textFromBody;
                    
                    const installmentAmount = Math.round(precioBase / installmentsCount);
                    const installmentAmountStr = formatearPrecio(installmentAmount);
                    
                    const installmentsHtml = `<div class="lop-installments-container" style="background-color: ${bgColor}; color: ${textColor};"><span>${installmentsCount} cuotas de $${installmentAmountStr} sin interes</span></div>`;
                    
                    // Eliminar cuotas previas si existen
                    const prevInstallments = infoInner.querySelector('.lop-installments-container');
                    if (prevInstallments) prevInstallments.remove();
                    
                    // SIEMPRE insertar al final del infoInner para garantizar posición consistente
                    infoInner.insertAdjacentHTML('beforeend', installmentsHtml);
                  }
                }
              }
              
              console.log(`Activados precios por defecto para agrupador "${agrupador}"`);
            }
          }
        } catch (e) { 
          console.log('Error procesando precios personalizados:', e);
        }
      } else {
        console.log(`No hay JSON global o agrupador para el swatch ${index + 1}`);
      }
    });

    // PASO FINAL: Agregar cuotas a TODOS los productos que no las tengan
    agregarCuotasATodosLosProductos();

    // Log para debugging
    const totalCards = document.querySelectorAll('.product-card').length;
    const cardsWithCustomPrices = document.querySelectorAll('.product-card .precio-personalizado-container').length;
    const cardsWithDefaultPrices = document.querySelectorAll('.product-card .price').length;
    
    console.log(`Procesados ${cardsWithCustomPrices} de ${totalCards} tarjetas con precios personalizados`);
    console.log(`Tarjetas con precios por defecto: ${cardsWithDefaultPrices}`);
    
    // Si hay muy pocas tarjetas con precios, mostrar información adicional
    if (cardsWithCustomPrices < totalCards * 0.1) { // Menos del 10%
      console.log('⚠️ ADVERTENCIA: Muy pocas tarjetas tienen precios personalizados');
      console.log('Verificando estructura de datos...');
      
      // Verificar si el JSON global tiene datos
      const globalJson = document.getElementById('agrupadores-precios-json-global');
      if (globalJson) {
        try {
          const agrupadores = JSON.parse(globalJson.textContent);
          console.log('Agrupadores en JSON global:', Object.keys(agrupadores));
        } catch (e) {
          console.log('Error parseando JSON global:', e);
        }
      }
      
      // Verificar swatches disponibles
      const swatchDivs = document.querySelectorAll('.product-card-swatches[data-product-handle]');
      console.log('Swatches disponibles:', swatchDivs.length);
      swatchDivs.forEach((div, index) => {
        const agrupador = div.getAttribute('data-agrupador');
        const colorName = div.getAttribute('data-color-name');
        const handle = div.getAttribute('data-product-handle');
        console.log(`Swatch ${index + 1}:`, { agrupador, colorName, handle });
      });
    }
  }

  // Sistema de debounce para evitar múltiples llamadas
  let processingTimeout = null;
  let isProcessing = false;
  
  // FUNCIÓN MEJORADA para inicializar swatches con debounce
  function initializeSwatches(source = 'unknown') {
    // Evitar llamadas durante paginación activa
    if (window._paginationProcessing) {
      console.log(`⏸️ initializeSwatches ignorado durante paginación (source: ${source})`);
      return;
    }
    
    // Debounce: cancelar timeout anterior si existe
    if (processingTimeout) {
      clearTimeout(processingTimeout);
    }
    
    processingTimeout = setTimeout(() => {
      if (isProcessing) {
        console.log(`⏸️ Ya procesando, ignorando llamada (source: ${source})`);
        return;
      }
      
      isProcessing = true;
      console.log(`🔄 Inicializando swatches (source: ${source})...`);
      
      // Procesar todos los productos, incluyendo los de carruseles
      procesarPreciosProductos();
      
      // Procesar de nuevo después de un pequeño delay para asegurar que los carruseles estén listos
      setTimeout(() => {
        // Verificar si hay carruseles y procesar sus productos
        const carousels = document.querySelectorAll('.products.carousel, .featured-collection__inner, .collection-tabs--products');
        if (carousels.length > 0) {
          console.log(`Detectados ${carousels.length} carruseles, procesando swatches adicionales...`);
          procesarPreciosProductos();
        }
        
        procesarDescuentosFicticios();
        procesarDescuentosFicticiosProducto();
        
        isProcessing = false;
        
        // Disparar evento personalizado cuando los swatches estén listos
        window.dispatchEvent(new CustomEvent('swatchesInitialized', {
          detail: { timestamp: Date.now() }
        }));
      }, 300);
    }, 100); // Debounce de 100ms
  }

  // RECARGAR configuración al inicio (para obtener los settings más recientes)
  console.log('🔄 Recargando configuración de colorMap...');
  
  const reloadedColorMap = loadColorMapFromSettings();
  if (reloadedColorMap && Object.keys(reloadedColorMap).length > 0) {
    colorMap = reloadedColorMap;
    console.log('✅ Recarga exitosa: theme settings con', Object.keys(colorMap).length, 'colores');
  } else {
    colorMap = getDefaultColorMap();
    console.log('🎨 Recarga fallback: colorMap por defecto con', Object.keys(colorMap).length, 'colores');
  }
  
  colorLimits = getColorLimitsFromSettings();
  
  console.log('🎯 Configuración LOP cargada:', {
    swatchesHabilitados: !!Object.keys(colorMap).length,
    totalColores: Object.keys(colorMap).length,
    limitesDesktop: colorLimits.desktop,
    limitesMobile: colorLimits.mobile,
    ejemploColores: Object.keys(colorMap).slice(0, 5)
  });
  
  // Debug adicional: verificar si hay elementos de swatches en la página
  const swatchContainers = document.querySelectorAll('.product-card-swatches[data-product-handle]');
  console.log('🔍 Contenedores de swatches encontrados:', swatchContainers.length);
  
  if (swatchContainers.length === 0) {
    console.log('⚠️ NO se encontraron contenedores de swatches. Verificar:');
    console.log('   - Que haya productos en la página');
    console.log('   - Que los productos tengan metafields de agrupador y color');
    console.log('   - Que los contenedores tengan las clases correctas');
  }

  // EJECUTAR LA PRIMERA VEZ
  initializeSwatches('initial-load');

  // Función global para cargar swatches faltantes en la PDP via AJAX
  // Compara los handles del JSON completo vs. los renderizados por Liquid
  window.cargarSwatchesFaltantes = function() {
    var jsonEl = document.querySelector('.agrupador-all-handles');
    var grid = document.querySelector('.agrupador-swatches-grid');
    if (!jsonEl || !grid) return;
    var allHandles = JSON.parse(jsonEl.textContent);
    var currentHandle = window.location.pathname.split('/products/')[1];
    if (currentHandle) currentHandle = currentHandle.split('?')[0].split('/')[0];

    var rendered = new Set();
    grid.querySelectorAll('.swatch-item[data-handle]').forEach(function(el) {
      var h = (el.getAttribute('data-handle') || '').trim().toLowerCase();
      if (h) rendered.add(h);
    });

    console.log('[cargarSwatchesFaltantes] Rendered en DOM:', Array.from(rendered));
    console.log('[cargarSwatchesFaltantes] Handles del JSON:', allHandles);

    var unique = [];
    var seen = new Set();
    allHandles.forEach(function(h) {
      var norm = (h || '').trim().toLowerCase();
      if (norm && !seen.has(norm) && !rendered.has(norm)) {
        seen.add(norm);
        unique.push(h.trim());
      }
    });

    console.log('[cargarSwatchesFaltantes] Faltantes a crear:', unique);
    if (!unique.length) return;

    unique.forEach(function(handle) {
      fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.product && data.product.image) {
            var div = document.createElement('div');
            div.className = 'swatch-item';
            div.setAttribute('data-handle', handle);
            div.style.cssText = 'cursor:pointer; border: 2px solid ' + (handle === currentHandle ? '#333' : '#eee') + '; border-radius: 6px; padding: 2px;';
            var img = document.createElement('img');
            img.src = data.product.image.src;
            img.alt = data.product.title || '';
            img.style.cssText = 'display:block;width:70px;object-fit:cover;border-radius:4px;';
            div.appendChild(img);
            grid.appendChild(div);
          }
        })
        .catch(function() {});
    });
  };

  window.cargarSwatchesFaltantes();
  
  // PROCESAMIENTO ADICIONAL PARA CARRUSELES AL CARGAR LA PÁGINA
  // Asegurar que todos los productos en carruseles se procesen, incluso los ocultos
  window.addEventListener('load', () => {
    console.log('Página completamente cargada, procesando todos los carruseles...');
    
    // Forzar procesamiento de todos los swatches después de que todo esté cargado
    setTimeout(() => {
      procesarPreciosProductos();
      
      // Si hay carruseles específicos, procesarlos individualmente
      const featuredCollections = document.querySelectorAll('.featured-collection__inner .product-card');
      if (featuredCollections.length > 0) {
        console.log(`Procesando ${featuredCollections.length} productos en Featured Collections`);
        procesarPreciosProductos();
      }
    }, 500);
  });

  /**
   * Collection tabs / featured collection: el LOP inserta cuotas, precios, cucardas dentro de tarjetas ya existentes.
   * Esas mutaciones no son "productos nuevos"; sin filtrar, el observer puede disparar initializeSwatches en bucle.
   */
  function lopMutationEsSoloInyeccionLopEnCarruselHome(mutation) {
    if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) return false;
    const raw = mutation.target;
    const targetEl = raw && raw.nodeType === 1 ? raw : raw && raw.parentElement;
    if (!targetEl || typeof targetEl.closest !== 'function') {
      return false;
    }
    if (!targetEl.closest('.collection-tabs') && !targetEl.closest('.featured-collection')) {
      return false;
    }
    for (let i = 0; i < mutation.addedNodes.length; i++) {
      const node = mutation.addedNodes[i];
      if (node.nodeType !== 1) continue;
      if (node.classList && (node.classList.contains('product-card') || node.classList.contains('product-cart-item'))) {
        return false;
      }
      if (node.querySelector && (node.querySelector('.product-card') || node.querySelector('.product-cart-item'))) {
        return false;
      }
      if (node.classList && node.classList.contains('collection-tabs--product') && node.querySelector && node.querySelector('.product-card')) {
        return false;
      }
    }
    return true;
  }

  // OBSERVADOR DE CAMBIOS EN EL DOM mejorado para detectar nuevo contenido
  const observer = new MutationObserver(function(mutations) {
    let shouldReprocess = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        if (lopMutationEsSoloInyeccionLopEnCarruselHome(mutation)) {
          return;
        }
        // Verificar si se agregaron nuevas tarjetas de producto
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Verificar product-card y product-cart-item (usado en búsqueda)
            if (node.classList && (node.classList.contains('product-card') || node.classList.contains('product-cart-item'))) {
              shouldReprocess = true;
            } else if (node.querySelector) {
              // Buscar cualquier tarjeta de producto
              if (node.querySelector('.product-card, .product-cart-item')) {
                shouldReprocess = true;
              }
              // Verificar contenedores de productos
              if (node.querySelector('#product-grid, .products.carousel, .featured-collection__inner, .collection-tabs--product, .LOP-slider-crocs-lop-inner, .thb-predictive-search--content')) {
                shouldReprocess = true;
              }
            }
            // Verificar si es un contenedor de búsqueda predictiva
            if (node.classList && node.classList.contains('thb-predictive-search--container')) {
              shouldReprocess = true;
            }
          }
        });
      }
    });
    
    if (shouldReprocess) {
      // No procesar si la paginación está activa (ella maneja su propio procesamiento)
      if (window._paginationProcessing) {
        console.log('⏸️ MutationObserver: ignorando durante paginación');
        return;
      }
      console.log('Detectados nuevos productos, re-inicializando swatches...');
      // Pequeño delay para asegurar que el contenido esté completamente renderizado
      setTimeout(function() {
        initializeSwatches('MutationObserver');
      }, 300);
    }
  });

  // OBSERVAR CAMBIOS EN EL BODY Y ESPECÍFICAMENTE EN EL GRID DE PRODUCTOS
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // OBSERVAR ESPECÍFICAMENTE EL GRID DE PRODUCTOS
  const productGrid = document.getElementById('product-grid');
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }

  // OBSERVAR CARRUSELES DE FEATURED COLLECTION
  const carousels = document.querySelectorAll('.products.carousel, .featured-collection__inner');
  carousels.forEach(function(carousel) {
    observer.observe(carousel, {
      childList: true,
      subtree: true
    });
  });

  // ESCUCHAR EVENTOS DE PAGINACIÓN específicos de Shopify
  document.addEventListener('click', function(e) {
    if (e.target.matches('.pagination__link') || 
        e.target.closest('.pagination__link') ||
        e.target.matches('[data-pagination]') ||
        e.target.closest('[data-pagination]') ||
        e.target.matches('a[href*="page="]') ||
        e.target.closest('a[href*="page="]')) {
      
      console.log('Detectado clic en paginación, reprocesando precios...');
      // Reprocesar después de la navegación
      setTimeout(function() {
        initializeSwatches('click-pagination');
      }, 1000);
    }
  });

  // DETECTAR CAMBIOS EN LA URL (para paginación AJAX)
  let currentUrl = window.location.href;
  const urlObserver = new MutationObserver(function(mutations) {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      console.log('Detectado cambio de URL, reprocesando precios...');
      setTimeout(function() {
        initializeSwatches('url-change');
      }, 500);
    }
  });

  // HACER LA FUNCIÓN GLOBAL para que otros scripts puedan llamarla
  window.initializeProductSwatches = initializeSwatches;

  // ESCUCHAR EVENTO DE PAGINACIÓN (pagination:page-changed) del paginador AJAX
  document.addEventListener('pagination:page-changed', function(e) {
    console.log('📄 Evento pagination:page-changed detectado');
    
    // Marcar que estamos procesando paginación para evitar interferencia del MutationObserver
    window._paginationProcessing = true;
    
    // DEBUG: Revisar los productos nuevos cargados
    setTimeout(function() {
      const allCards = document.querySelectorAll('.product-card');
      console.log('🔍 DEBUG PAGINACIÓN - Total de product-cards en el DOM:', allCards.length);
      
      // Contar cuántos NO tienen cuotas
      const sinCuotas = Array.from(allCards).filter(c => !c.querySelector('.lop-installments-container'));
      console.log(`📊 Productos SIN cuotas: ${sinCuotas.length} de ${allCards.length}`);
      
      // Revisar los últimos 8 productos (los que probablemente se acaban de cargar)
      const lastCards = Array.from(allCards).slice(-8);
      lastCards.forEach((card, i) => {
        const handle = card.getAttribute('data-product-handle');
        const descuento = card.getAttribute('data-collection-descuento');
        const cucarda = card.getAttribute('data-collection-cucarda-titulo');
        const precio = card.getAttribute('data-product-price');
        const tieneCuotas = card.querySelector('.lop-installments-container');
        const tieneCucarda = card.querySelector('.LOP-cucarda-descuento');
        
        console.log(`📦 Producto ${i+1}: ${handle}`, {
          'data-collection-descuento': descuento || 'NO TIENE',
          'data-collection-cucarda-titulo': cucarda || 'NO TIENE',
          'data-product-price': precio,
          'tiene cuotas badge': !!tieneCuotas,
          'tiene cucarda descuento': !!tieneCucarda
        });
      });
      
      // Ahora procesar
      console.log('⏳ Procesando precios y cucardas...');
      procesarPreciosProductos();
      
      setTimeout(function() {
        procesarDescuentosFicticios();
        procesarDescuentosFicticiosProducto();
        
        // IMPORTANTE: Reubicar cuotas al final DESPUÉS de todos los procesamientos
        // Esto garantiza que siempre aparezcan debajo de todos los elementos de precio
        agregarCuotasATodosLosProductos();
        
        // Verificar resultado
        const sinCuotasAfter = Array.from(document.querySelectorAll('.product-card')).filter(c => !c.querySelector('.lop-installments-container'));
        console.log(`✅ Procesamiento completado. Productos SIN cuotas después: ${sinCuotasAfter.length}`);
        
        // Liberar el flag después de procesar
        window._paginationProcessing = false;
      }, 200);
    }, 300);
  });

  // DETECTAR EVENTOS DE FLICKITY (carruseles)
  // Esperar un momento para que Flickity se inicialice
  setTimeout(() => {
    // Buscar todos los elementos con Flickity
    const flickityElements = document.querySelectorAll('[data-flickity], .flickity-enabled');
    
    flickityElements.forEach(elem => {
      // Collection tabs usa theme-scroll, no Flickity; si hubiera instancia aquí, reprocesar dispara bucle con el DOM.
      if (elem && typeof elem.closest === 'function' && elem.closest('.collection-tabs')) {
        return;
      }
      // Verificar si el elemento tiene Flickity inicializado
      if (elem && elem.flickityGUID) {
        console.log('Agregando listener a carrusel Flickity');
        
        // Agregar listener para cuando cambie el slide
        elem.addEventListener('change.flickity', () => {
          console.log('Cambio de slide detectado, procesando swatches...');
          setTimeout(() => {
            procesarPreciosProductos();
          }, 100);
        });
        
        // También escuchar el evento settle (cuando termina la animación)
        elem.addEventListener('settle.flickity', () => {
          console.log('Slide establecido, procesando swatches...');
          procesarPreciosProductos();
        });
      }
    });
    
    // También intentar con jQuery si está disponible
    if (typeof jQuery !== 'undefined' && jQuery.fn.flickity) {
      jQuery('.featured-collection__inner, .products.carousel').on('change.flickity settle.flickity', function() {
        if (this.closest && this.closest('.collection-tabs')) {
          return;
        }
        console.log('Evento Flickity detectado via jQuery');
        setTimeout(() => {
          procesarPreciosProductos();
        }, 100);
      });
    }
  }, 1000);

  // Observar cambios en el título de la página (indica navegación)
  const titleElement = document.querySelector('title');
  if (titleElement) {
    urlObserver.observe(titleElement, {
      childList: true,
      subtree: true
    });
  }

  // ESCUCHAR EVENTOS DE AJAX mejorado (para themes que usan AJAX para paginación)
  // Debounce: en preview/editor Shopify hay muchas respuestas text/html seguidas → bucle de swatches/cuotas.
  let lopFetchHtmlDebounceTimer = null;
  let originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (response.headers.get('content-type') && response.headers.get('content-type').includes('text/html')) {
        clearTimeout(lopFetchHtmlDebounceTimer);
        lopFetchHtmlDebounceTimer = setTimeout(function() {
          console.log('Detectada respuesta AJAX HTML (agrupada), reprocesando precios...');
          procesarPreciosProductos();
          setTimeout(() => {
            procesarDescuentosFicticios();
            procesarDescuentosFicticiosProducto();
          }, 100);
        }, 650);
      }
      return response;
    });
  };

  // ESCUCHAR EVENTOS DE POPSTATE (navegación del navegador)
  window.addEventListener('popstate', function() {
    console.log('Detectado popstate, reprocesando precios...');
    setTimeout(function() {
      procesarPreciosProductos();
    }, 500);
  });

  // ESCUCHAR EVENTOS DE PUSHSTATE (navegación programática)
  const originalPushState = history.pushState;
  history.pushState = function(...args) {
    originalPushState.apply(this, args);
    console.log('Detectado pushState, reprocesando precios...');
    setTimeout(function() {
      procesarPreciosProductos();
    }, 500);
  };

  // REPROCESAR PERIÓDICAMENTE para asegurar que funcione (misma noción de “listo” que PLP / descuentos LOP)
  setInterval(function() {
    if (hasProducts()) {
      const { total: totalCards, pending: pendingLop } = countProductCardsPendingLopPricing();

      if (totalCards > 0 && pendingLop > 0) {
        console.log(`Detectadas ${pendingLop} tarjetas sin LOP completo (precio/cuotas), reprocesando...`);
        procesarPreciosProductos();
        setTimeout(() => {
          procesarDescuentosFicticios();
          procesarDescuentosFicticiosProducto();
        }, 100);
      }
    }
  }, 5000);

  // Swatches en la página de producto
  const swatchDiv = document.getElementById('product-page-swatches');
  const grupoJson = document.getElementById('agrupador-colores-json');
  if (swatchDiv && grupoJson) {
    const grupoFromServer = JSON.parse(grupoJson.textContent);
    const agrupadorKey = swatchDiv.dataset.agrupador;
    const currentHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];

    // Función para renderizar swatches PDP a partir de un grupo de productos
    function renderPdpSwatches(grupo) {
      const coloresMostrados = new Set();
      swatchDiv.innerHTML = "";

      const currentColorObj = grupo.find(prod => prod.handle === currentHandle);
      let currentColorName = currentColorObj ? currentColorObj.colorName : '';

      const colorNameSpan = document.createElement('span');
      colorNameSpan.className = 'nombre-color-seleccionado';
      colorNameSpan.style.marginLeft = '12px';
      colorNameSpan.style.fontWeight = 'bold';
      colorNameSpan.style.fontSize = '16px';
      colorNameSpan.style.color = '#222';
      colorNameSpan.textContent = currentColorName;

      const coloresValidosProducto = grupo.filter(prod =>
        getColorMapValue(prod.colorName) && !coloresMostrados.has(prod.colorName)
      );
      const totalColoresProducto = coloresValidosProducto.length;

      grupo.forEach(prod => {
        if (getColorMapValue(prod.colorName) && !coloresMostrados.has(prod.colorName)) {
          const swatch = createSwatch(prod.colorName, prod.handle, currentHandle, 0, 0);
          swatch.addEventListener('click', function() {
            colorNameSpan.textContent = prod.colorName;
          });
          swatchDiv.appendChild(swatch);
          coloresMostrados.add(prod.colorName);
        }
      });

      swatchDiv.appendChild(colorNameSpan);
      return { colorNameSpan, currentColorName };
    }

    // Merge con cache de sessionStorage
    let grupo = [...grupoFromServer];
    if (agrupadorKey) {
      try {
        const cached = JSON.parse(sessionStorage.getItem('agrupador_' + agrupadorKey) || '[]');
        const handleSet = new Set(grupo.map(p => p.handle));
        cached.forEach(p => { if (!handleSet.has(p.handle)) { grupo.push(p); handleSet.add(p.handle); } });
      } catch (e) { /* ignore */ }
    }

    // Render inicial con datos disponibles
    renderPdpSwatches(grupo);

    // Buscar productos faltantes via AJAX API de Shopify (250 productos por request vs 50 de Liquid)
    const collectionsJson = document.getElementById('product-collections-json');
    if (collectionsJson && agrupadorKey) {
      const collHandles = JSON.parse(collectionsJson.textContent);

      // Computar prefijo de handle común del grupo (ej: "classic-clog-c10001-")
      function computeHandlePrefix(handles) {
        if (handles.length === 0) return '';
        if (handles.length === 1) {
          const parts = handles[0].split('-');
          return parts.length > 1 ? parts.slice(0, -1).join('-') + '-' : handles[0];
        }
        let prefix = handles[0];
        for (let i = 1; i < handles.length; i++) {
          while (handles[i].indexOf(prefix) !== 0 && prefix.length > 0) {
            prefix = prefix.substring(0, prefix.length - 1);
          }
        }
        const lastDash = prefix.lastIndexOf('-');
        if (lastDash > 0) prefix = prefix.substring(0, lastDash + 1);
        return prefix;
      }

      const knownHandles = grupo.map(p => p.handle);
      const handlePrefix = computeHandlePrefix(knownHandles);

      if (handlePrefix.length > 5 && collHandles.length > 0) {
        // Intentar con la primera colección que no sea "all" (más pequeña = más rápida)
        const targetColl = collHandles.find(h => h !== 'all') || collHandles[0];

        fetch('/collections/' + targetColl + '/products.json?limit=250')
          .then(r => r.json())
          .then(data => {
            if (!data.products) return;
            const handleSet = new Set(grupo.map(p => p.handle));
            let added = 0;

            data.products.forEach(p => {
              if (p.handle.startsWith(handlePrefix) && !handleSet.has(p.handle)) {
                const colorName = p.options && p.options[0] ? p.options[0].values[0] : '';
                if (colorName) {
                  grupo.push({ handle: p.handle, colorName: colorName });
                  handleSet.add(p.handle);
                  added++;
                }
              }
            });

            if (added > 0) {
              console.log('PDP swatches: encontrados ' + added + ' colores adicionales via AJAX');
              renderPdpSwatches(grupo);
              // Actualizar cache
              try { sessionStorage.setItem('agrupador_' + agrupadorKey, JSON.stringify(grupo)); } catch (e) { /* ignore */ }
            }
          })
          .catch(err => console.warn('Error buscando productos adicionales:', err));
      }

      // Guardar cache inicial
      try { sessionStorage.setItem('agrupador_' + agrupadorKey, JSON.stringify(grupo)); } catch (e) { /* ignore */ }
    }

    // colorNameSpan ahora se agrega dentro de renderPdpSwatches
  }
});

// Panel lateral de búsqueda avanzado - VERSIÓN FINAL
(function() {
  const inputBuscador = document.getElementById('header-search-input');
  const searchPanel = document.getElementById('search-panel');
  const sideInput = document.getElementById('side-search-input');
  const sideProducts = document.getElementById('side-search-products');
  const sideForm = document.getElementById('side-search-form');
  const searchButton = document.querySelector('.side-search-button');

  if (!inputBuscador || !searchPanel || !sideInput || !sideProducts) return;

  let executingSearch = false;
  let panelJustOpened = false; // Variable para evitar cierre inmediato

  function ejecutarBusqueda(query) {
    if (query && query.trim().length > 0 && !executingSearch) {
      executingSearch = true;
      window.location.href = `/search?q=${encodeURIComponent(query.trim())}`;
    }
  }

  function cerrarPanel() {
    searchPanel.classList.remove('activo');
    setTimeout(() => searchPanel.classList.add('oculto'), 300);
    document.body.classList.remove('open-search');
    panelJustOpened = false; // Reset flag
  }

  function abrirPanel() {
    panelJustOpened = true; // Marcar que el panel se acaba de abrir
    searchPanel.classList.remove('oculto');
    setTimeout(() => {
      searchPanel.classList.add('activo');
      sideInput.focus();
      // Reset flag después de un momento para permitir el cierre normal
      setTimeout(() => {
        panelJustOpened = false;
      }, 300); // Aumentado de 100ms a 300ms
    }, 10);
    document.body.classList.add('open-search');
  }

  // Prevenir que clicks dentro del panel cierren el modal
  searchPanel.addEventListener('click', function(e) {
    e.stopPropagation();
  });

  searchPanel.addEventListener('mousedown', function(e) {
    e.stopPropagation();
  });

  // Prevenir propagación en toda la búsqueda
  const searchContent = searchPanel.querySelector('.search-panel__content');
  if (searchContent) {
    searchContent.addEventListener('click', function(e) {
      e.stopPropagation();
    });
    searchContent.addEventListener('mousedown', function(e) {
      e.stopPropagation();
    });
  }

  // Abrir panel al hacer focus en el input del header
  inputBuscador.addEventListener('focus', function() {
    abrirPanel();
  });

  // CERRAR PANEL CON EL BOTÓN X - VERSIÓN MEJORADA
  const closeButton = document.querySelector('.search-panel__close');
  if (closeButton) {
    // Eliminar cualquier listener previo clonando el elemento
    const newCloseButton = closeButton.cloneNode(true);
    closeButton.parentNode.replaceChild(newCloseButton, closeButton);
    
    // Agregar el nuevo event listener
    newCloseButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      cerrarPanel();
    });
    
    // También agregar mousedown como backup
    newCloseButton.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  // Cerrar panel con Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchPanel.classList.contains('activo')) {
      cerrarPanel();
    }
  });

  // Cerrar panel con overlay - DESHABILITADO
  const overlay = document.querySelector('.search-panel__overlay');
  if (overlay) {
    // IMPORTANTE: Eliminar el overlay del flujo normal o hacer que no interfiera
    overlay.style.pointerEvents = 'none'; // Hace que el overlay no capture clicks
  }

  // BÚSQUEDA CON EL BOTÓN DE LA LUPA
  if (searchButton) {
    // Eliminar listeners previos
    const newSearchButton = searchButton.cloneNode(true);
    searchButton.parentNode.replaceChild(newSearchButton, searchButton);
    
    newSearchButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const value = sideInput.value.trim();
      if (value) {
        ejecutarBusqueda(value);
      }
    });
  }

  // Búsqueda con Enter en el input
  if (sideInput) {
    sideInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        const value = sideInput.value.trim();
        if (value) {
          ejecutarBusqueda(value);
        }
      }
    });
  }

  // Submit del formulario
  if (sideForm) {
    sideForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const value = sideInput.value.trim();
      if (value) {
        ejecutarBusqueda(value);
      }
    });
  }

  // Cerrar panel con clicks externos - CON PROTECCIÓN ANTI-CIERRE-INMEDIATO
  document.addEventListener('mousedown', function(e) {
    // No hacer nada si el panel se acaba de abrir
    if (panelJustOpened) {
      return;
    }
    
    if (!searchPanel.classList.contains('activo')) return;
    
    // Verificar si el mousedown fue dentro del área del panel (excluyendo overlay)
    const clickedInsideContent = e.target.closest('.search-panel__content');
    const clickedInputHeader = e.target.closest('#header-search-input');
    const clickedSearchSubmit = e.target.closest('.thb-search-submit');
    const clickedSearchButton = e.target.closest('.side-search-button');
    
    // Solo cerrar si el mousedown NO fue en el contenido del panel ni en elementos de búsqueda
    if (!clickedInsideContent && !clickedInputHeader && !clickedSearchSubmit && !clickedSearchButton) {
      cerrarPanel();
    }
  });

  // --- Buscador lateral: suggest.json (product_object oficial) no incluye "collections" → LOP no podía
  // resolverse con el JSON inyectado. Se enriquece con /products/{handle}.js y, sin compare_at, con
  // Section Rendering: lop-search-product-discount (misma lógica que product-card).
  function lopReadSideSearchCollectionDiscounts() {
    const el = document.getElementById('lop-side-search-descuentos-coleccion');
    if (!el) return { byHandle: {}, byTitle: {} };
    try {
      const d = JSON.parse(el.textContent);
      return {
        byHandle: d.byHandle && typeof d.byHandle === 'object' ? d.byHandle : {},
        byTitle: d.byTitle && typeof d.byTitle === 'object' ? d.byTitle : {}
      };
    } catch (e) {
      return { byHandle: {}, byTitle: {} };
    }
  }

  function lopGetHandleFromProductUrl(url) {
    if (!url) return '';
    const m = String(url).match(/\/products\/([^?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function lopStoreRootPrefix() {
    let r = window.theme && window.theme.routes && window.theme.routes.root_url;
    r = r != null && r !== '' ? String(r) : '/';
    return r.endsWith('/') ? r : r + '/';
  }

  function lopEscapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function lopFormatPesosArg(n) {
    const v = Math.round(Number(n) || 0);
    if (typeof formatearPrecio === 'function') {
      return formatearPrecio(v);
    }
    return v.toLocaleString('es-AR');
  }

  /** Precio de variant en Ajax API Shopify (centavos) → pesos de tienda (como en Liquid: price | divided_by: 100) */
  function lopCentsToDisplayPesos(cents) {
    if (cents == null || cents === '') return 0;
    return Math.round(Number(cents) / 100);
  }

  function lopParseSuggestPricePesos(raw) {
    if (raw == null || raw === '') return 0;
    const t = String(raw).replace(/[^\d.]/g, '');
    if (!t) return 0;
    const n = parseFloat(t);
    return isNaN(n) ? 0 : Math.round(n);
  }

  /** suggest.json: compare_at/price en unidades de moneda (no centavos), p. ej. 99999 */
  function lopParseSuggestPriceDecimalUnits(raw) {
    if (raw == null || raw === '' || raw === '0' || raw === '0.00') return 0;
    const n = parseFloat(String(raw).replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n);
  }

  const LOP_SECTION_LQPCT_ID = 'lop-search-product-discount';
  const lopSectionPctCache = Object.create(null);

  function lopParseLopPctFromSectionData(data) {
    if (!data || typeof data !== 'object') return 0;
    const html = data[LOP_SECTION_LQPCT_ID];
    if (!html || typeof html !== 'string') return 0;
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('.lop-search-discount-fragment[data-lop-pct]');
      if (!el) return 0;
      const raw = el.getAttribute('data-lop-pct');
      if (raw == null || String(raw).trim() === '') return 0;
      const p = parseFloat(raw);
      return !isNaN(p) && p > 0 ? p : 0;
    } catch (e) {
      return 0;
    }
  }

  function lopFetchLopPercentForHandle(handle) {
    if (!handle) return Promise.resolve(0);
    if (Object.prototype.hasOwnProperty.call(lopSectionPctCache, handle)) {
      return Promise.resolve(lopSectionPctCache[handle]);
    }
    const url =
      lopStoreRootPrefix() +
      'products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      encodeURIComponent(LOP_SECTION_LQPCT_ID);
    return fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const pct = lopParseLopPctFromSectionData(data);
        lopSectionPctCache[handle] = pct;
        return pct;
      })
      .catch(() => {
        lopSectionPctCache[handle] = 0;
        return 0;
      });
  }

  function lopExtractProductJsPrices(productJs) {
    let pricePesos = 0;
    let comparePesos = null;
    if (productJs) {
      if (productJs.price_min != null) {
        pricePesos = lopCentsToDisplayPesos(productJs.price_min);
      } else if (productJs.price != null) {
        pricePesos = lopCentsToDisplayPesos(productJs.price);
      } else if (productJs.variants && productJs.variants.length) {
        pricePesos = lopCentsToDisplayPesos(productJs.variants[0].price);
      }
      if (productJs.compare_at_price_min != null && productJs.compare_at_price_min !== '') {
        const cpm = lopCentsToDisplayPesos(productJs.compare_at_price_min);
        if (cpm > 0) comparePesos = cpm;
      } else if (productJs.compare_at_price != null && productJs.compare_at_price !== '') {
        const ca = lopCentsToDisplayPesos(productJs.compare_at_price);
        if (ca > 0) comparePesos = ca;
      } else if (productJs.variants && productJs.variants.length) {
        const v0 = productJs.variants[0];
        if (v0 && v0.compare_at_price != null && v0.compare_at_price !== '') {
          const cv = lopCentsToDisplayPesos(v0.compare_at_price);
          if (cv > 0) comparePesos = cv;
        }
      }
    }
    return { pricePesos: pricePesos, comparePesos: comparePesos };
  }

  function lopProductJsHasNativeCompareSale(productJs) {
    if (!productJs) return false;
    const o = lopExtractProductJsPrices(productJs);
    return o.comparePesos != null && o.comparePesos > o.pricePesos && o.pricePesos > 0;
  }

  function lopLopPercentFromSuggestCollections(sug, maps) {
    if (!sug || !sug.collections || !sug.collections.length) return 0;
    for (let i = 0; i < sug.collections.length; i++) {
      const col = sug.collections[i];
      if (!col) continue;
      if (col.handle && maps.byHandle[col.handle] != null && String(maps.byHandle[col.handle]).trim() !== '') {
        const p = parseFloat(maps.byHandle[col.handle]);
        if (!isNaN(p) && p > 0) return p;
      }
      if (col.title && maps.byTitle[col.title] != null && String(maps.byTitle[col.title]).trim() !== '') {
        const p2 = parseFloat(maps.byTitle[col.title]);
        if (!isNaN(p2) && p2 > 0) return p2;
      }
    }
    return 0;
  }

  function lopBuildSideSearchPriceHtml(sug, productJs, lopPctFromSection) {
    const maps = lopReadSideSearchCollectionDiscounts();
    const fromJs = lopExtractProductJsPrices(productJs);
    let pricePesos = fromJs.pricePesos;
    let comparePesos = fromJs.comparePesos;

    if (pricePesos <= 0) {
      pricePesos = lopParseSuggestPricePesos(sug && sug.price);
    }
    if (pricePesos <= 0 && sug) {
      pricePesos = lopParseSuggestPriceDecimalUnits(sug.price_min) || lopParseSuggestPriceDecimalUnits(sug.price);
    }

    if (comparePesos == null && sug) {
      const cSug = lopParseSuggestPriceDecimalUnits(sug.compare_at_price_min);
      const pSug = lopParseSuggestPriceDecimalUnits(sug.price_min) || lopParseSuggestPriceDecimalUnits(sug.price);
      if (cSug > 0 && pSug > 0 && cSug > pSug) {
        if (pricePesos <= 0) pricePesos = pSug;
        comparePesos = cSug;
      }
    }

    if (comparePesos != null && comparePesos > pricePesos && pricePesos > 0) {
      return (
        '<span class="side-search-price-row">' +
        '<del class="side-search-price-compare">$' + lopFormatPesosArg(comparePesos) + '</del> ' +
        '<ins class="side-search-price-current LOP-precio-descuento">$' + lopFormatPesosArg(pricePesos) + '</ins>' +
        '</span>'
      );
    }

    let lopPct =
      lopPctFromSection != null && lopPctFromSection > 0
        ? lopPctFromSection
        : lopLopPercentFromSuggestCollections(sug, maps);
    if (lopPct > 0 && pricePesos > 0) {
      const conDesc = Math.round(pricePesos - (pricePesos * lopPct) / 100);
      if (conDesc > 0 && conDesc < pricePesos) {
        return (
          '<span class="side-search-price-row">' +
          '<del class="side-search-price-compare">$' + lopFormatPesosArg(pricePesos) + '</del> ' +
          '<ins class="side-search-price-current LOP-precio-descuento">$' + lopFormatPesosArg(conDesc) + '</ins> ' +
          '<span class="side-search-cucarda">' + String(Math.round(lopPct)) + '% OFF</span>' +
          '</span>'
        );
      }
    }

    return '<span class="side-search-price-single">$' + lopFormatPesosArg(pricePesos) + '</span>';
  }

  function lopRenderSideSearchProducts(suggestList, productJsList, lopPctList) {
    if (!suggestList || !suggestList.length) {
      sideProducts.innerHTML = '<div style="padding:16px;color:#888;">No se encontraron productos.</div>';
      return;
    }
    sideProducts.innerHTML = suggestList
      .map((sug, idx) => {
        const pJs = productJsList && productJsList[idx] ? productJsList[idx] : null;
        const lopP =
          lopPctList && typeof lopPctList[idx] === 'number' && lopPctList[idx] > 0 ? lopPctList[idx] : 0;
        const collection = sug.collections && sug.collections.length > 0 ? sug.collections[0].title : '';
        const href = lopEscapeHtml(sug.url || '#');
        const title = lopEscapeHtml(sug.title || '');
        const img =
          (sug.featured_image && sug.featured_image.url && lopEscapeHtml(sug.featured_image.url)) ||
          (sug.image && lopEscapeHtml(sug.image)) ||
          '';
        return (
          '<a href="' + href + '" class="side-search-product-item side-search-link">' +
          '<img class="side-search-product-img" src="' + img + '" alt="' + title + '" />' +
          '<div class="side-search-product-info">' +
          '<span class="side-search-product-title">' + title + '</span>' +
          (collection ? '<div class="side-search-product-meta">' + lopEscapeHtml(collection) + '</div>' : '') +
          '<div class="side-search-product-price">' + lopBuildSideSearchPriceHtml(sug, pJs, lopP) + '</div>' +
          '</div></a>'
        );
      })
      .join('');
  }

  let lopSearchSeq = 0;

  function searchShopifyProducts(query) {
    if (!query || query.length < 2) {
      sideProducts.innerHTML = '';
      lopSearchSeq += 1;
      return;
    }

    const seq = ++lopSearchSeq;
    sideProducts.innerHTML =
      '<div class="side-search-loading" style="padding:12px 16px;color:#666;font-size:14px;">Buscando…</div>';

    const sp =
      lopStoreRootPrefix() +
      'search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=4';

    fetch(sp)
      .then((res) => res.json())
      .then((data) => {
        if (seq !== lopSearchSeq) return;
        const list =
          data && data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products
            : [];
        if (!list.length) {
          lopRenderSideSearchProducts([], [], []);
          return;
        }
        return Promise.all(
          list.map((p) => {
            const h = lopGetHandleFromProductUrl(p.url);
            if (!h) return Promise.resolve(null);
            return fetch(lopStoreRootPrefix() + 'products/' + encodeURIComponent(h) + '.js')
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null);
          })
        ).then((jsList) => {
          if (seq !== lopSearchSeq) return;
          return Promise.all(
            list.map((sug, idx) => {
              const pJs = jsList[idx];
              if (lopProductJsHasNativeCompareSale(pJs)) return Promise.resolve(0);
              const h = lopGetHandleFromProductUrl(sug.url);
              return h ? lopFetchLopPercentForHandle(h) : Promise.resolve(0);
            })
          ).then((lopPcts) => {
            if (seq !== lopSearchSeq) return;
            lopRenderSideSearchProducts(list, jsList, lopPcts);
          });
        });
      })
      .catch(() => {
        if (seq !== lopSearchSeq) return;
        lopRenderSideSearchProducts([], [], []);
      });
  }

  const lopDebounceSearch = debounce(function (q) {
    searchShopifyProducts(q);
  }, 280);

  sideInput.addEventListener('input', function (e) {
    lopDebounceSearch(e.target.value);
  });

  // EXPONER función para uso externo
  window.abrirPanelBusqueda = abrirPanel;

})();

// CÓDIGO PARA ABRIR EL PANEL (mantener separado)
document.addEventListener('DOMContentLoaded', function() {
  const searchBtn = document.querySelector('.thb-search-submit');
  const searchSvg = document.querySelector('.thb-search-submit svg');
  const searchInput = document.getElementById('header-search-input');

  function abrirPanelBusqueda(e) {
    if (e) e.preventDefault();
    
    // Marcar que el panel se va a abrir para evitar cierre inmediato
    if (window.panelJustOpened !== undefined) {
      window.panelJustOpened = true;
      setTimeout(() => {
        window.panelJustOpened = false;
      }, 500);
    }
    
    // Usar la función expuesta por el módulo principal
    if (window.abrirPanelBusqueda) {
      window.abrirPanelBusqueda();
    }
  }

  if (searchBtn) searchBtn.addEventListener('click', abrirPanelBusqueda);
  if (searchSvg) searchSvg.addEventListener('click', abrirPanelBusqueda);
  
  // Focus también abre el panel, pero esto ya está manejado en el módulo principal
});

  // FUNCIÓN para formatear precio con puntos de miles
  function formatearPrecio(precio) {
    return precio.toLocaleString('es-AR');
  }

  // FUNCIÓN para obtener el texto del precio sin impuestos según el tamaño de pantalla
  function obtenerTextoPrecioSinImpuestos(precioFormateado) {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      return `Precio sin imp país: $${precioFormateado}`;
    }
    return `Precio sin Impuestos Nacionales: $${precioFormateado}`;
  }

  // FUNCIÓN para actualizar todos los textos de precio sin impuestos cuando cambia el tamaño de pantalla
  function actualizarTextosPrecioSinImpuestos() {
    const elementos = document.querySelectorAll(
      '.product-price-without-taxes:not(.product-price-without-taxes-personalizado) small, .product-price-without-taxes-personalizado small'
    );
    elementos.forEach(elemento => {
      const texto = elemento.textContent;
      const match = texto.match(/\$([\d.,]+)/);
      if (match) {
        const precioFormateado = match[1];
        elemento.textContent = obtenerTextoPrecioSinImpuestos(precioFormateado);
      }
    });
  }

  // Listener para actualizar textos cuando cambia el tamaño de la ventana
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(actualizarTextosPrecioSinImpuestos, 250);
  });

  // FUNCIÓN para forzar precio básico en un producto
  function forzarPrecioBasicoProducto(card) {
    const infoInner = card.querySelector('.product-card-info--inner');
    if (!infoInner) return;

    // En PLP el product-card ya trae .price y product-price-without-taxes (Liquid). No inyectar duplicados.
    if (infoInner.querySelector('.price')) {
      return;
    }

    // Obtener precio real del producto
    const precioReal = obtenerPrecioReal(card);
    if (!precioReal || precioReal === 0) return;

    const precioFormateado = formatearPrecio(precioReal);
    
    // Obtener impuesto del producto
    const impuesto = obtenerImpuestoProducto(card);
    const divisor = 1 + (impuesto / 100);
    const precioSinImpuesto = Math.round((precioReal / divisor));
    const precioSinImpuestoStr = formatearPrecio(precioSinImpuesto);
    const textoPrecioSinImpuestos = obtenerTextoPrecioSinImpuestos(precioSinImpuestoStr);
    
    // Guardar referencia a las cuotas si existen para reubicarlas después
    const existingInstallments = infoInner.querySelector('.lop-installments-container');
    if (existingInstallments) {
      existingInstallments.remove();
    }
    
    // Crear precio básico
    const priceHtml = `<div class="precio-personalizado-container" style="margin: 8px 0; display: block;">
      <span class="precio-minimo" style="color: #222; font-size: 18px; font-weight: bold; font-family: var(--font-crocs-regular), Arial, sans-serif;">$${precioFormateado}</span>
    </div>
    <div class="product-price-without-taxes-personalizado" style="margin-top: 4px;">
      <small style="font-family: var(--font-crocs-regular), Arial, sans-serif;">${textoPrecioSinImpuestos}</small>
    </div>`;
    
    infoInner.insertAdjacentHTML('beforeend', priceHtml);
    
    // Si había cuotas, re-insertarlas al final (después del precio sin impuestos)
    if (existingInstallments) {
      infoInner.appendChild(existingInstallments);
    }
  }

  // FUNCIONES PARA DESCUENTOS FICTICIOS
  function aplicarDescuentoFicticio(precio, porcentajeDescuento) {
    if (!porcentajeDescuento || porcentajeDescuento <= 0) return precio;
    const descuento = precio * (porcentajeDescuento / 100);
    return Math.round(precio - descuento);
  }

  function crearCucardaDescuento(texto, colorFondo) {
    const cucarda = document.createElement('div');
    cucarda.className = 'LOP-cucarda-descuento LOP-cucarda-porcentaje';
    cucarda.textContent = texto;
    
    // Aplicar estilos en línea para asegurar visibilidad
    cucarda.style.cssText = `
      position: absolute !important;
      top: 12px !important;
      left: 12px !important;
      background: ${colorFondo || '#000'} !important;
      color: #fff !important;
      padding: 8px !important;
      border-radius: 4px !important;
      font-size: 14px !important;
      font-weight: bold !important;
      z-index: 20 !important;
      text-transform: uppercase !important;
      display: inline-block !important;
    `;
    
    return cucarda;
  }

  // Cucarda para mostrar junto al precio en vista de producto individual
  function crearCucardaPrecio(texto, colorFondo) {
    const cucarda = document.createElement('span');
    cucarda.className = 'LOP-cucarda-descuento LOP-cucarda-precio';
    cucarda.textContent = texto;
    
    // Aplicar estilos inline para posición junto al precio (SOBREESCRIBIR position absolute)
    cucarda.style.setProperty('position', 'static', 'important');
    cucarda.style.setProperty('display', 'inline-block', 'important');
    cucarda.style.setProperty('vertical-align', 'middle', 'important');
    cucarda.style.setProperty('margin-left', '12px', 'important');
    cucarda.style.setProperty('background', colorFondo || '#368617', 'important');
    cucarda.style.setProperty('color', '#fff', 'important');
    cucarda.style.setProperty('padding', '6px 12px', 'important');
    cucarda.style.setProperty('border-radius', '4px', 'important');
    cucarda.style.setProperty('font-size', '14px', 'important');
    cucarda.style.setProperty('font-weight', 'bold', 'important');
    cucarda.style.setProperty('text-transform', 'uppercase', 'important');
    cucarda.style.setProperty('font-family', 'var(--font-crocs-bold), Arial, sans-serif', 'important');
    cucarda.style.setProperty('letter-spacing', '0.5px', 'important');
    cucarda.style.setProperty('line-height', '1.2', 'important');
    cucarda.style.setProperty('top', 'auto', 'important');
    cucarda.style.setProperty('left', 'auto', 'important');
    cucarda.style.setProperty('right', 'auto', 'important');
    cucarda.style.setProperty('bottom', 'auto', 'important');
    cucarda.style.setProperty('visibility', 'visible', 'important');
    cucarda.style.setProperty('opacity', '1', 'important');
    
    return cucarda;
  }

  function crearCucardaTexto(texto, colorFondo) {
    const cucarda = document.createElement('div');
    cucarda.className = 'LOP-cucarda-descuento LOP-cucarda-texto';
    cucarda.textContent = texto;
    
    // Aplicar estilos en línea para asegurar visibilidad
    cucarda.style.cssText = `
      position: absolute !important;
      top: 45px !important;
      left: 12px !important;
      background: ${colorFondo || '#000'} !important;
      color: #fff !important;
      padding: 8px !important;
      border-radius: 4px !important;
      font-size: 14px !important;
      font-weight: bold !important;
      z-index: 20 !important;
      text-transform: uppercase !important;
      display: inline-block !important;
    `;
    
    return cucarda;
  }

  /**
   * Precio entero en pesos para descuento de colección: NO usar textContent de .price completo
   * (compare_at en <del> + sale en <ins> concatena dígitos y rompe el layout).
   * Orden: data-product-price en tarjeta → <ins> .amount dentro de .price.
   */
  function lopObtenerPrecioBasePesosTarjeta(card) {
    if (!card) return 0;
    const rawAttr = card.getAttribute('data-product-price');
    if (rawAttr) {
      const n = parseInt(String(rawAttr).replace(/[^\d]/g, ''), 10);
      if (!isNaN(n) && n > 0) return n;
    }
    const priceRoot = card.querySelector('.price');
    if (!priceRoot) return 0;
    const insAmt = priceRoot.querySelector('ins .amount, ins .money');
    if (insAmt) {
      const t = insAmt.textContent.replace(/[^\d]/g, '');
      if (t) {
        const n = parseInt(t, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    const one = priceRoot.querySelector('.amount.precio-minimo');
    if (one) {
      const t = one.textContent.replace(/[^\d]/g, '');
      if (t) {
        const n = parseInt(t, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return 0;
  }

  /** Misma lógica en PDP / contenedor raíz (variant price, ins .amount). */
  function lopObtenerPrecioBasePesosDesdeRoot(root) {
    if (!root) return 0;
    const attrHost = root.matches && root.matches('[data-product-price]') ? root : root.querySelector('[data-product-price]');
    if (attrHost) {
      const raw = attrHost.getAttribute('data-product-price');
      if (raw) {
        const n = parseInt(String(raw).replace(/[^\d]/g, ''), 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    const priceRoot = root.querySelector('.product--price-container .price, .sticky-scroller .price, .price');
    if (!priceRoot) return 0;
    const insAmt = priceRoot.querySelector('ins .amount, ins .money');
    if (insAmt) {
      const t = insAmt.textContent.replace(/[^\d]/g, '');
      if (t) {
        const n = parseInt(t, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    const one = priceRoot.querySelector('.amount.precio-minimo');
    if (one) {
      const t = one.textContent.replace(/[^\d]/g, '');
      if (t) {
        const n = parseInt(t, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return 0;
  }

  function lopCardTieneOfertaShopifyNative(card) {
    const priceRoot = card && card.querySelector ? card.querySelector('.price') : null;
    if (!priceRoot) return false;
    const delAmt = priceRoot.querySelector('del .amount, del .money');
    const insAmt = priceRoot.querySelector('ins .amount, ins .money');
    if (!delAmt || !insAmt) return false;
    const a = parseInt(String(delAmt.textContent).replace(/[^\d]/g, ''), 10);
    const b = parseInt(String(insAmt.textContent).replace(/[^\d]/g, ''), 10);
    return !isNaN(a) && !isNaN(b) && a > 0 && b > 0 && b < a;
  }

  /**
   * Precio en pesos para calcular cuotas en tarjeta: debe coincidir con el importe **efectivo** (verde),
   * no con el tachado ni con un data-product-price desalineado.
   * Orden: .LOP-precio-descuento → desc. colección (sin oferta Shopify del/ins) → ins → .precio-minimo → data-product-price.
   */
  function lopObtenerPrecioBaseCuotasProductCard(card) {
    if (!card) return 0;
    const lopDesc = card.querySelector('.LOP-precio-descuento');
    if (lopDesc) {
      const t = lopDesc.textContent.replace(/[^\d]/g, '');
      if (t) {
        const n = parseInt(t, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    const pctAttr = card.getAttribute('data-collection-descuento');
    const pct = pctAttr != null && String(pctAttr).trim() !== '' ? parseFloat(pctAttr) : NaN;
    if (!isNaN(pct) && pct > 0 && !lopCardTieneOfertaShopifyNative(card)) {
      const baseLista = lopObtenerPrecioBasePesosTarjeta(card);
      if (baseLista > 0) {
        const conDesc = aplicarDescuentoFicticio(baseLista, pct);
        if (conDesc > 0 && conDesc < baseLista) return conDesc;
      }
    }
    const priceRoot = card.querySelector('.price');
    if (priceRoot) {
      const insAmt = priceRoot.querySelector('ins .amount, ins .money');
      if (insAmt) {
        const t = insAmt.textContent.replace(/[^\d]/g, '');
        if (t) {
          const n = parseInt(t, 10);
          if (!isNaN(n) && n > 0) return n;
        }
      }
      const one = priceRoot.querySelector('.amount.precio-minimo');
      if (one) {
        const t = one.textContent.replace(/[^\d]/g, '');
        if (t) {
          const n = parseInt(t, 10);
          if (!isNaN(n) && n > 0) return n;
        }
      }
    }
    const rawAttr = card.getAttribute('data-product-price');
    if (rawAttr) {
      const n = parseInt(String(rawAttr).replace(/[^\d]/g, ''), 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return 0;
  }

  function procesarDescuentosFicticios() {
    const productCards = document.querySelectorAll('.product-card');
    let cucardasCreadas = 0;
    
    productCards.forEach((card, index) => {
      // Carrito y búsqueda: muchos re-disparos (timeouts 100–3000 ms, fetch, observer). Sin skip,
      // se vuelve a ejecutar aplicarDescuentoAPrecios sobre nodos ya formateados → parseInt acumula
      // dígitos y el precio "crece". En PLP con swatches mantenemos el flujo anterior (no skip aquí).
      const path = window.location.pathname || '';
      const usarIdempotenciaTarjeta =
        path === '/cart' || path.endsWith('/cart') || path.includes('/search');
      if (usarIdempotenciaTarjeta) {
        const yaProceseado = card.querySelector('.LOP-precios-descuento-container') ||
          card.querySelector('.LOP-cucarda-descuento');
        if (yaProceseado) {
          return;
        }
      }
      // Buscar data attributes de metafields de colección
      const numeroDescuento = card.getAttribute('data-collection-descuento');
      const tituloCucarda = card.getAttribute('data-collection-cucarda-titulo');
      const colorCucardaTitulo = card.getAttribute('data-collection-cucarda-color-titulo');
      const colorCucardaDescuento = card.getAttribute('data-collection-cucarda-color-descuento');
      
      // Debug para ver qué productos están siendo procesados
      // console.log(`🔍 Producto ${index + 1}:`, {
      //   numeroDescuento: numeroDescuento,
      //   tituloCucarda: tituloCucarda,
      //   tieneDescuento: numeroDescuento && parseFloat(numeroDescuento) > 0,
      //   productHandle: card.getAttribute('data-product-handle') || 'No handle'
      // });
      
      // Si no hay metafields, asegurar que al menos tenga precios básicos en colecciones
      if (!numeroDescuento && !tituloCucarda) {
        // En páginas de colecciones, forzar precios básicos si no existen
        if (window.location.pathname.includes('/collections/')) {
          const precioExistente = card.querySelector('.precio-personalizado-container');
          if (!precioExistente) {
            forzarPrecioBasicoProducto(card);
          }
        }
        return;
      }
      
      // Limpiar TODAS las cucardas anteriores del producto completo (excepto preventa)
      const todasLasCucardas = card.querySelectorAll('.LOP-cucarda-descuento:not(.LOP-cucarda-preventa)');
      todasLasCucardas.forEach(cucarda => {
        cucarda.remove();
      });
      
      // Crear cucarda
      const imageContainer = card.querySelector('.product-card-image, .product-card-image-link');
      const figureContainer = card.querySelector('.product-card-image'); // Buscar también el figure
      const containerToUse = imageContainer || figureContainer;
      
      if (containerToUse) {
        let cucardaTexto = '';
        let cucardaColor = '#000';
        
        // Limpiar TODAS las cucardas existentes antes de crear nuevas (excepto preventa)
        const cucardasExistentes = containerToUse.querySelectorAll('.LOP-cucarda-descuento:not(.LOP-cucarda-preventa)');
        cucardasExistentes.forEach(cucarda => cucarda.remove());
        
        // Crear cucardas independientemente - pueden coexistir
        let cucardasCreadasEnProducto = 0;
        
        // Cucarda de descuento (si existe) - SIEMPRE ARRIBA
        if (numeroDescuento && parseFloat(numeroDescuento) > 0) {
          // console.log(`✅ Aplicando descuento del ${numeroDescuento}% al producto ${index + 1}`);
          const cucardaDescuento = crearCucardaDescuento(`${numeroDescuento}% OFF`, colorCucardaDescuento || '#368617');
          cucardaDescuento.style.top = '12px';
          cucardaDescuento.style.left = '12px';
          cucardaDescuento.style.zIndex = '1001';
          containerToUse.style.position = 'relative';
          containerToUse.appendChild(cucardaDescuento);
          cucardasCreadas++;
          cucardasCreadasEnProducto++;
          

          
          // Aplicar descuento a los precios
          aplicarDescuentoAPrecios(card, parseFloat(numeroDescuento));
        } else {
          // console.log(`❌ Producto ${index + 1}: NO tiene descuento válido (${numeroDescuento})`);
        }
        
        // Cucarda de texto personalizado (si existe) - SIEMPRE ABAJO
        if (tituloCucarda && tituloCucarda.trim() !== '') {
          const cucardaTexto = crearCucardaTexto(tituloCucarda.trim(), colorCucardaTitulo || '#000');
          containerToUse.style.position = 'relative';
          containerToUse.appendChild(cucardaTexto);
          cucardasCreadas++;
          cucardasCreadasEnProducto++;
          

        }
      }
      
      // No necesitamos marcar como procesado con el nuevo enfoque
    });
  }

  // Procesar descuentos ficticios en vista de producto individual
  function procesarDescuentosFicticiosProducto() {
    const productDetail = document.querySelector('.thb-product-detail.product');
    if (!productDetail) return;
    
    // Verificar si ya se procesó para evitar duplicados
    if (productDetail.hasAttribute('data-cucardas-procesadas')) {
      console.log('⚠️ Cucardas ya procesadas anteriormente, saltando...');
      return;
    }
    
    // Buscar data attributes de metafields de colección
    const numeroDescuento = productDetail.getAttribute('data-collection-descuento');
    const tituloCucarda = productDetail.getAttribute('data-collection-cucarda-titulo');
    const colorCucardaTitulo = productDetail.getAttribute('data-collection-cucarda-color-titulo');
    const colorCucardaDescuento = productDetail.getAttribute('data-collection-cucarda-color-descuento');
    
    // Debug: mostrar qué metafields tiene el producto
    console.log('🔍 Producto individual metafields:', {
      descuento: numeroDescuento,
      cucarda: tituloCucarda,
      colorTitulo: colorCucardaTitulo,
      colorDescuento: colorCucardaDescuento
    });
    
    // Buscar contenedor de precios personalizados
    const precioContainer = productDetail.querySelector('.sticky-scroller .precio-personalizado-container') || productDetail.querySelector('.precio-personalizado-container');
    
    // Si no hay metafields de descuento NI de cucarda de texto, limpiar todo y ocultar
    if (!numeroDescuento && !tituloCucarda) {
      console.log('❌ No hay metafields de descuento ni cucarda de texto, limpiando elementos de descuento');
      
      // Limpiar cucardas existentes (excepto preventa)
      const cucardasExistentes = productDetail.querySelectorAll('.LOP-cucarda-descuento:not(.LOP-cucarda-preventa)');
      cucardasExistentes.forEach(cucarda => cucarda.remove());
      
      // Limpiar precios con descuento existentes
      const preciosDescuentoExistentes = productDetail.querySelectorAll('.LOP-precios-descuento-container');
      preciosDescuentoExistentes.forEach(el => el.remove());
      
      // Restaurar visibilidad del precio original de Shopify
      const precioOriginalShopify = productDetail.querySelector('.sticky-scroller .price') || productDetail.querySelector('.price');
      if (precioOriginalShopify) {
        precioOriginalShopify.style.display = '';
      }
      
      if (precioContainer) {
        precioContainer.style.display = 'none';
      }
      
      // Agregar badge de preventa si corresponde (incluso sin descuentos)
      if (typeof agregarBadgePreventa === 'function') {
        agregarBadgePreventa(productDetail);
      }
      
      // Marcar que ya se procesó para evitar reprocesamiento
      productDetail.setAttribute('data-cucardas-procesadas', 'true');
      return;
    }

    // Si solo hay descuento pero no hay cucarda de texto, ocultar contenedor de precios personalizados
    if (numeroDescuento && !tituloCucarda && precioContainer) {
      precioContainer.style.display = 'none';
    }
    
    // Limpiar cucardas existentes (excepto preventa)
    const cucardasExistentes = productDetail.querySelectorAll('.LOP-cucarda-descuento:not(.LOP-cucarda-preventa)');
    cucardasExistentes.forEach(cucarda => cucarda.remove());
    
    let cucardasCreadasEnProducto = 0;
    let imageCucardaContainerCount = 0;
    
    // ========================================
    // CUCARDA DE DESCUENTO (% OFF) - JUNTO AL PRECIO
    // ========================================
    if (numeroDescuento && parseFloat(numeroDescuento) > 0) {
      // Buscar contenedores de precio para insertar la cucarda
      // Priorizar el contenedor de precios con descuento que ya existe
      const preciosDescuentoContainers = productDetail.querySelectorAll('.LOP-precios-descuento-container');
      const priceContainers = productDetail.querySelectorAll('.product--price-container .price, .product--price-container [id^="price-"]');
      
      console.log('🔍 Buscando contenedores para cucarda de precio:', {
        preciosDescuento: preciosDescuentoContainers.length,
        priceContainers: priceContainers.length
      });
      
      // Insertar cucarda en cada contenedor de precios con descuento encontrado
      preciosDescuentoContainers.forEach((container, index) => {
        // Verificar si ya tiene una cucarda
        if (container.querySelector('.LOP-cucarda-precio')) {
          console.log(`⏭️ Contenedor ${index} ya tiene cucarda, saltando`);
          return;
        }
        
        const cucardaPrecio = crearCucardaPrecio(`${numeroDescuento}% OFF`, colorCucardaDescuento || '#368617');
        container.appendChild(cucardaPrecio);
        cucardasCreadasEnProducto++;
        
        // Detectar si es móvil por el contenedor padre
        const isMobile = container.closest('.product--only-title-container--mobile') !== null;
        if (isMobile) {
          cucardaPrecio.style.fontSize = '12px';
          cucardaPrecio.style.padding = '4px 8px';
          cucardaPrecio.style.marginLeft = '8px';
        }
        
        console.log(`✅ Cucarda creada en LOP-precios-descuento-container ${index} (${isMobile ? 'mobile' : 'desktop'}): "${numeroDescuento}% OFF"`);
      });
      
      // Si no hay contenedores de precios con descuento, buscar en .price
      if (preciosDescuentoContainers.length === 0) {
        priceContainers.forEach((container, index) => {
          // Verificar si ya tiene una cucarda
          if (container.querySelector('.LOP-cucarda-precio')) {
            return;
          }
          
          const cucardaPrecio = crearCucardaPrecio(`${numeroDescuento}% OFF`, colorCucardaDescuento || '#368617');
          container.appendChild(cucardaPrecio);
          cucardasCreadasEnProducto++;
          
          const isMobile = container.closest('.product--only-title-container--mobile') !== null;
          if (isMobile) {
            cucardaPrecio.style.fontSize = '12px';
            cucardaPrecio.style.padding = '4px 8px';
            cucardaPrecio.style.marginLeft = '8px';
          }
          
          console.log(`✅ Cucarda creada en price container ${index}: "${numeroDescuento}% OFF"`);
        });
      }
      
      // Aplicar descuento a los precios
      aplicarDescuentoAPreciosProducto(productDetail, parseFloat(numeroDescuento));
    }
    
    // ========================================
    // CUCARDA DE TEXTO - EN LA IMAGEN (si existe)
    // ========================================
    if (tituloCucarda && tituloCucarda.trim() !== '') {
      // Buscar contenedores de imagen para la cucarda de texto
      const desktopContainer = productDetail.querySelector('.product-single__media-image, .product-images__slide, .product-single__media, .aspect-ratio, .product-single__media-image-link');
      const mobileImageContainer = productDetail.querySelector('.product-single-image-mobile');
      const mobileCarouselContainer = productDetail.querySelector('.product-carousel-slide:first-child');
      
      const imageContainers = [];
      if (desktopContainer) imageContainers.push({ container: desktopContainer, isMobile: false });
      if (mobileImageContainer) imageContainers.push({ container: mobileImageContainer, isMobile: true });
      if (mobileCarouselContainer) imageContainers.push({ container: mobileCarouselContainer, isMobile: true });
      
      imageCucardaContainerCount = imageContainers.length;
      
      imageContainers.forEach(({ container, isMobile }) => {
        const cucardaTexto = crearCucardaTexto(tituloCucarda.trim(), colorCucardaTitulo || '#000');
        
        // Posicionar arriba ya que la cucarda de % ya no está en la imagen
        if (isMobile) {
          cucardaTexto.style.top = '8px';
          cucardaTexto.style.left = '8px';
          cucardaTexto.style.fontSize = '12px';
          cucardaTexto.style.padding = '4px 8px';
        } else {
          cucardaTexto.style.top = '12px';
          cucardaTexto.style.left = '12px';
        }
        
        cucardaTexto.style.zIndex = '9999';
        cucardaTexto.style.cssText += 'display: block !important; visibility: visible !important; opacity: 1 !important;';
        
        container.style.position = 'relative';
        container.appendChild(cucardaTexto);
        cucardasCreadasEnProducto++;
        
        console.log(`✅ Cucarda texto creada en imagen: "${tituloCucarda.trim()}"`, { isMobile });
      });
    }
    
    console.log(`🎯 Total cucardas creadas en producto individual: ${cucardasCreadasEnProducto}`);
    
    // Verificar cuántas cucardas hay realmente en el DOM de todos los contenedores
    const todasLasCucardas = productDetail.querySelectorAll('.LOP-cucarda-descuento');
    console.log('🔍 Cucardas totales encontradas en DOM después de crear:', {
      total: todasLasCucardas.length,
      porcentaje: productDetail.querySelectorAll('.LOP-cucarda-porcentaje').length,
      texto: productDetail.querySelectorAll('.LOP-cucarda-texto').length,
      contenedores: imageCucardaContainerCount
    });
    
    // Marcar que ya se procesaron las cucardas
    productDetail.setAttribute('data-cucardas-procesadas', 'true');
    
    // ========================================
    // BADGE DE PREVENTA - Agregar si corresponde
    // ========================================
    agregarBadgePreventa(productDetail);
  }
  
  // Función para agregar badge de preventa
  function agregarBadgePreventa(productDetail) {
    // Verificar si es un producto de preventa (template suffix)
    const templatePreventa = document.body.classList.contains('template-product-preventa') || 
                             document.querySelector('[data-template-suffix="preventa"]') ||
                             window.location.pathname.includes('preventa');
    
    // También verificar por el form del producto
    const productForm = productDetail.querySelector('product-form[template="preventa"]');
    
    if (!templatePreventa && !productForm) {
      return;
    }
    
    console.log('🏷️ Producto de preventa detectado, agregando badge...');
    
    // Buscar contenedores donde agregar el badge
    const priceContainers = productDetail.querySelectorAll('.LOP-precios-descuento-container, .price');
    
    priceContainers.forEach(container => {
      // Verificar si ya tiene el badge
      if (container.querySelector('.LOP-badge-preventa')) {
        return;
      }
      
      // Crear el badge
      const badge = document.createElement('span');
      badge.className = 'LOP-badge-preventa';
      badge.textContent = 'PREVENTA';
      badge.style.cssText = 'display: inline-block !important; vertical-align: middle !important; margin-left: 12px !important; background: rgb(159, 208, 110) !important; color: rgb(255, 255, 255) !important; padding: 6px 12px !important; border-radius: 4px !important; font-size: 14px !important; font-weight: bold !important; text-transform: uppercase !important; font-family: Arial, sans-serif !important; letter-spacing: 0.5px !important; line-height: 1.2 !important;';
      
      container.appendChild(badge);
      console.log('✅ Badge de preventa agregado a:', container.className);
    });
  }

  // Exponer la función en window para que sea accesible desde otros archivos
  window.procesarDescuentosFicticiosProducto = procesarDescuentosFicticiosProducto;
  window.agregarBadgePreventa = agregarBadgePreventa;

  // Función auxiliar para encontrar el precio real en la página
  function encontrarPrecioReal(productDetail) {
    // Buscar directamente el contenedor .price que es donde está el precio
    let precioElement = productDetail.querySelector('.sticky-scroller .price') || 
                        productDetail.querySelector('.price');
    
    if (precioElement) {
      console.log('✅ Encontrado elemento .price:', precioElement);
      return precioElement;
    }
    
    // Si no hay .price, buscar .amount y retornar su padre
    precioElement = productDetail.querySelector('.sticky-scroller .amount') || 
                    productDetail.querySelector('.amount');
    
    if (precioElement) {
      console.log('✅ Encontrado elemento .amount:', precioElement);
      const contenedorPadre = precioElement.closest('.price') || precioElement.parentElement;
      console.log('✅ Retornando contenedor padre:', contenedorPadre);
      return contenedorPadre;
    }
    
    console.log('❌ No se encontró elemento de precio');
    return null;
  }

  // Función auxiliar para debug del precio
  function debugPrecio(elemento, nombre) {
    console.log(`🔍 Debug ${nombre}:`, {
      tagName: elemento.tagName,
      className: elemento.className,
      id: elemento.id,
      innerHTML: elemento.innerHTML.substring(0, 100),
      visible: elemento.offsetParent !== null,
      display: window.getComputedStyle(elemento).display,
      visibility: window.getComputedStyle(elemento).visibility,
      opacity: window.getComputedStyle(elemento).opacity
    });
  }

  // Función auxiliar para ocultar otros precios que puedan interferir
  function ocultarOtrosPrecios(productDetail, precioActual) {
    const otrosPrecios = productDetail.querySelectorAll('.price:not(:first-child), .amount, .product--price-container .price, .product--price-container .amount');
    otrosPrecios.forEach(precio => {
      if (precio !== precioActual && !precio.closest('.LOP-precios-descuento-container')) {
        // Solo ocultar si no es el precio principal
        if (!precio.closest('.product--price-container')) {
          precio.style.display = 'none';
          console.log('🔍 Ocultando precio adicional:', precio);
        }
      }
    });
  }

  // Aplicar descuento a precios de producto individual
  function aplicarDescuentoAPreciosProducto(productDetail, porcentajeDescuento) {
    console.log(`🔍 Aplicando descuento del ${porcentajeDescuento}% a precios de producto individual`);
    
    // Verificar si ya se aplicó el descuento para evitar aplicarlo múltiples veces
    if (productDetail.hasAttribute('data-descuento-aplicado')) {
      console.log('⚠️ Descuento ya aplicado anteriormente, saltando...');
      return;
    }
    
    // Buscar contenedor de precios personalizados (dentro del sticky-scroller)
    const precioContainer = productDetail.querySelector('.sticky-scroller .precio-personalizado-container') || productDetail.querySelector('.precio-personalizado-container');
    
    console.log('🔍 Buscando contenedor de precios:', {
      stickyScroller: productDetail.querySelector('.sticky-scroller .precio-personalizado-container') ? 'Encontrado' : 'No encontrado',
      direct: productDetail.querySelector('.precio-personalizado-container') ? 'Encontrado' : 'No encontrado',
      final: precioContainer ? 'Encontrado' : 'No encontrado'
    });
    
    // Debug: verificar todos los elementos de precio en la página
    const todosLosPrecios = productDetail.querySelectorAll('.price, .amount, .product--price-container, .precio-personalizado-container');
    console.log('🔍 Todos los elementos de precio encontrados:', todosLosPrecios.length);
    todosLosPrecios.forEach((precio, index) => {
      console.log(`  Precio ${index + 1}:`, {
        elemento: precio.tagName,
        clase: precio.className,
        contenido: precio.textContent.substring(0, 50),
        visible: precio.offsetParent !== null,
        display: window.getComputedStyle(precio).display
      });
    });
    
    if (precioContainer) {
      console.log('✅ Contenedor de precios personalizados encontrado');
      console.log('🔍 Contenido del contenedor:', precioContainer.innerHTML);
      
      // Trabajar con precios personalizados (min/max)
      const precioMinElement = precioContainer.querySelector('.precio-minimo');
      const precioMaxElement = precioContainer.querySelector('.precio-maximo');
      
      // Obtener el precio principal del producto (usualmente el máximo)
      let precioOriginal = 0;
      
      if (precioMaxElement) {
        // Usar precio máximo como precio principal
        const precioText = precioMaxElement.textContent.replace(/[^\d]/g, '');
        precioOriginal = parseInt(precioText);
      } else if (precioMinElement) {
        // Fallback a precio mínimo si no hay máximo
        const precioText = precioMinElement.textContent.replace(/[^\d]/g, '');
        precioOriginal = parseInt(precioText);
      }
      
      if (precioOriginal > 0) {
        const precioConDescuento = aplicarDescuentoFicticio(precioOriginal, porcentajeDescuento);
        
        // console.log(`📊 Precio original: ${precioOriginal}, con descuento: ${precioConDescuento}`);
        
        // Verificar si realmente hay descuento aplicado
        const hayDescuentoReal = precioConDescuento < precioOriginal;
        
        if (!hayDescuentoReal) {
          // console.log('⚠️ No hay descuento real aplicado, manteniendo precios originales');
          return;
        }
        
        // Buscar TODOS los elementos de precio en la página para reemplazarlos
        const todosLosPrecios = productDetail.querySelectorAll('.price, .amount, .product--price-container .price, .product--price-container .amount');
        // console.log(`🔍 Encontrados ${todosLosPrecios.length} elementos de precio para reemplazar`);
        
        if (todosLosPrecios.length > 0) {
          // Ocultar el contenedor de precios personalizados para evitar duplicación
          precioContainer.style.display = 'none';
          
          // HTML para el descuento - lógica simplificada
          const htmlDescuento = `
            <div class="LOP-precios-descuento-container LOP-precios-responsive" style="display: flex !important; align-items: center !important; gap: 6px !important;">
              <span class="LOP-precio-original-tachado" style="color: #141215 !important; font-size: 15.25px !important; font-weight: 400 !important; line-height: 22.4px !important; text-decoration-line: line-through !important;">
                $${formatearPrecio(precioOriginal)}
              </span>
              <span class="LOP-precio-descuento" style="color: #368617 !important; font-weight: 700 !important; line-height: 22.4px !important;">$${formatearPrecio(precioConDescuento)}</span>
            </div>
          `;
          
          // Reemplazar TODOS los elementos de precio
          todosLosPrecios.forEach((precio, index) => {
            // console.log(`🔍 Reemplazando precio ${index + 1}:`, precio.tagName, precio.className);
            // console.log(`  Antes:`, precio.innerHTML.substring(0, 100));
            
            precio.innerHTML = htmlDescuento;
            
            // Forzar visibilidad
            precio.style.display = 'block !important';
            precio.style.visibility = 'visible !important';
            precio.style.opacity = '1 !important';
            
            // console.log(`  Después:`, precio.innerHTML.substring(0, 100));
          });
          
          // console.log(`✅ ${todosLosPrecios.length} elementos de precio reemplazados con descuento`);
        } else {
          // console.log('❌ No se encontraron elementos de precio para reemplazar');
        }
      } else if (precioMinElement) {
        // Precio único
        const precioText = precioMinElement.textContent.replace(/[^\d]/g, '');
        const precio = parseInt(precioText);
        const precioConDescuento = aplicarDescuentoFicticio(precio, porcentajeDescuento);
        
        console.log(`📊 Precio único: original=${precio}, con descuento=${precioConDescuento}`);
        
        // Buscar TODOS los elementos de precio en la página para reemplazarlos
        const todosLosPrecios = productDetail.querySelectorAll('.price, .amount, .product--price-container .price, .product--price-container .amount');
        console.log(`🔍 Encontrados ${todosLosPrecios.length} elementos de precio para reemplazar (precio único)`);
        
        if (todosLosPrecios.length > 0) {
          // Ocultar el contenedor de precios personalizados para evitar duplicación
          precioContainer.style.display = 'none';
          
          // HTML para el descuento de precio único
          const htmlDescuento = `
            <div class="LOP-precios-descuento-container">
              <span class="LOP-precio-original-tachado" style="color: #141215 !important; font-size: 15.25px !important; font-weight: 400 !important; line-height: 22.4px !important; text-decoration-line: line-through !important;">$${formatearPrecio(precio)}</span>
              <span class="LOP-precio-descuento" style="color: #368617 !important; font-weight: 700 !important; line-height: 22.4px !important;">$${formatearPrecio(precioConDescuento)}</span>
            </div>
          `;
          
          // Reemplazar TODOS los elementos de precio
          todosLosPrecios.forEach((precio, index) => {
            console.log(`🔍 Reemplazando precio único ${index + 1}:`, precio.tagName, precio.className);
            console.log(`  Antes:`, precio.innerHTML.substring(0, 100));
            
            precio.innerHTML = htmlDescuento;
            
            // Forzar visibilidad
            precio.style.display = 'block !important';
            precio.style.visibility = 'visible !important';
            precio.style.opacity = '1 !important';
            
            console.log(`  Después:`, precio.innerHTML.substring(0, 100));
          });
          
          console.log(`✅ ${todosLosPrecios.length} elementos de precio único reemplazados con descuento`);
        } else {
          console.log('❌ No se encontraron elementos de precio para reemplazar');
        }
      }
      
      // ACTUALIZAR precio sin impuestos cuando hay precio tachado - usar precio de oferta
      actualizarPrecioSinImpuestosConOferta(productDetail);
    } else {
      console.log('⚠️ No se encontró contenedor de precios personalizados, buscando precios por defecto');
      
      // Trabajar con precios por defecto si no hay personalizados
      const priceElement = encontrarPrecioReal(productDetail);
      console.log('🔍 Elemento de precio por defecto:', priceElement ? 'Encontrado' : 'No encontrado');
      if (priceElement) {
        const precio = lopObtenerPrecioBasePesosDesdeRoot(productDetail);
        if (precio > 0) {
          const precioConDescuento = aplicarDescuentoFicticio(precio, porcentajeDescuento);

          console.log(`📊 Precio por defecto: original=${precio}, con descuento=${precioConDescuento}`);

          priceElement.innerHTML = `
            <div class="LOP-precios-descuento-container">
              <span class="LOP-precio-original-tachado" style="color: #141215 !important; font-size: 15.25px !important; font-weight: 400 !important; line-height: 22.4px !important; text-decoration-line: line-through !important;">$${formatearPrecio(precio)}</span>
              <br>
              <span class="LOP-precio-descuento" style="color: #368617 !important; font-weight: 700 !important; line-height: 22.4px !important;">$${formatearPrecio(precioConDescuento)}</span>
            </div>
          `;

          console.log('✅ Precio por defecto actualizado con descuento');
        }
      } else {
        console.log('❌ No se encontraron elementos de precio');
        
        // Función de emergencia: crear un precio visible
        console.log('🚨 Creando precio de emergencia...');
        const precioContainer = productDetail.querySelector('.product--price-container');
        if (precioContainer) {
          const precioOriginal = 44999; // Precio por defecto
          const precioConDescuento = aplicarDescuentoFicticio(precioOriginal, porcentajeDescuento);
          
          precioContainer.innerHTML = `
            <div class="LOP-precios-descuento-container" style="display: block !important; visibility: visible !important;">
              <span class="LOP-precio-original-tachado" style="color: #141215 !important; font-size: 15.25px !important; font-weight: 400 !important; line-height: 22.4px !important; text-decoration-line: line-through !important;">$${formatearPrecio(precioOriginal)}</span>
              <br>
              <span class="LOP-precio-descuento" style="color: #368617 !important; font-weight: 700 !important; line-height: 22.4px !important;">$${formatearPrecio(precioConDescuento)}</span>
            </div>
          `;
          
          console.log('✅ Precio de emergencia creado');
        }
      }
    }
    
    // Marcar que ya se aplicó el descuento
    productDetail.setAttribute('data-descuento-aplicado', 'true');
    
    // Badge de preventa deshabilitado
    // if (typeof agregarBadgePreventa === 'function') {
    //   agregarBadgePreventa(productDetail);
    // }
    
    // Ocultar otros precios que puedan estar interfiriendo después de aplicar el descuento
    const precioActual = encontrarPrecioReal(productDetail);
    if (precioActual) {
      ocultarOtrosPrecios(productDetail, precioActual);
      
      // Debug completo del precio final
      debugPrecio(precioActual, 'precio final después de aplicar descuento');
      
      // Verificar que el precio esté visible
      console.log('🔍 Verificación final del precio:', {
        elemento: precioActual.tagName,
        clase: precioActual.className,
        contenido: precioActual.innerHTML.substring(0, 100),
        visible: precioActual.offsetParent !== null,
        display: window.getComputedStyle(precioActual).display,
        visibility: window.getComputedStyle(precioActual).visibility,
        opacity: window.getComputedStyle(precioActual).opacity
      });
      
      // Forzar visibilidad si no está visible
      if (precioActual.offsetParent === null || window.getComputedStyle(precioActual).display === 'none') {
        console.log('⚠️ Precio no visible, forzando visibilidad...');
        precioActual.style.display = 'block !important';
        precioActual.style.visibility = 'visible !important';
        precioActual.style.opacity = '1 !important';
        precioActual.style.position = 'static !important';
      }
      
      // Forzar aplicación de estilos CSS para precios tachados
      const precioOriginal = precioActual.querySelector('.LOP-precio-original-tachado') || precioActual.querySelector('.LOP-precio-original');
      const precioDescuento = precioActual.querySelector('.LOP-precio-descuento');
      
      if (precioOriginal) {
        precioOriginal.style.setProperty('color', '#141215', 'important');
        precioOriginal.style.setProperty('text-decoration-line', 'line-through', 'important');
        precioOriginal.style.setProperty('font-size', '15.25px', 'important');
        precioOriginal.style.setProperty('font-weight', '400', 'important');
        precioOriginal.style.setProperty('line-height', '22.4px', 'important');
        console.log('✅ Estilos aplicados al precio original');
      }
      
      if (precioDescuento) {
        precioDescuento.style.setProperty('color', '#368617', 'important');
        precioDescuento.style.setProperty('text-decoration', 'none', 'important');
        precioDescuento.style.setProperty('font-size', '16px', 'important');
        precioDescuento.style.setProperty('font-weight', '700', 'important');
        precioDescuento.style.setProperty('line-height', '22.4px', 'important');
        console.log('✅ Estilos aplicados al precio con descuento');
      }
    }
    
    // Actualizar precio sin impuestos y cuotas después de aplicar descuento
    actualizarPrecioSinImpuestosConOferta(productDetail);
    actualizarCuotasDespuesDescuento(productDetail);
  }

  function aplicarDescuentoAPrecios(card, porcentajeDescuento) {
    const productHandle = card.getAttribute('data-product-handle') || 'Sin handle';
    // console.log(`🎯 EJECUTANDO aplicarDescuentoAPrecios para producto: ${productHandle}, descuento: ${porcentajeDescuento}%`);

    // Limpiar precios con descuento anteriores solo si ya hay más de uno (evitar acumulación)
    const preciosDescuentoAnteriores = card.querySelectorAll('.LOP-precios-descuento-container');
    if (preciosDescuentoAnteriores.length > 1) {
      preciosDescuentoAnteriores.forEach(precio => precio.remove());
    }

    // Ya reemplazamos .price con LOP: releer textContent concatena tachado + oferta → números enormes
    if (card.querySelector('.price .LOP-precios-descuento-container')) {
      actualizarPrecioSinImpuestosConOferta(card);
      actualizarCuotasDespuesDescuento(card);
      return;
    }
    
    // Buscar contenedor de precios personalizados
    const precioContainer = card.querySelector('.precio-personalizado-container');
    
    if (precioContainer) {
      // Obtener el precio principal del producto (usualmente el máximo)
      let precioOriginal = 0;
      
      // Buscar el precio principal - priorizar precio máximo si existe
      const precioMaxElement = precioContainer.querySelector('.precio-maximo');
      const precioMinElement = precioContainer.querySelector('.precio-minimo');
      
      if (precioMaxElement) {
        // Usar precio máximo como precio principal
        const precioText = precioMaxElement.textContent.replace(/[^\d]/g, '');
        precioOriginal = parseInt(precioText);
      } else if (precioMinElement) {
        // Fallback a precio mínimo si no hay máximo
        const precioText = precioMinElement.textContent.replace(/[^\d]/g, '');
        precioOriginal = parseInt(precioText);
      }
      
      if (precioOriginal > 0) {
        const precioConDescuento = aplicarDescuentoFicticio(precioOriginal, porcentajeDescuento);
        
        // Verificar si realmente hay descuento aplicado
        const hayDescuentoReal = precioConDescuento < precioOriginal;
        
        if (hayDescuentoReal) {
          // Aplicar descuento solo al precio principal, mantener el formato original de Shopify
          precioContainer.innerHTML = `
            <div class="LOP-precios-descuento-container LOP-precios-responsive" style="display: flex !important; align-items: center !important; gap: 8px !important;">
              <span class="LOP-precio-original-tachado" style="color: #141215 !important; font-size: 15.25px !important; font-weight: 400 !important; line-height: 22.4px !important; text-decoration-line: line-through !important;">
                $${formatearPrecio(precioOriginal)}
              </span>
              <span class="LOP-precio-descuento" style="color: #368617 !important; font-weight: 700 !important; line-height: 22.4px !important;">$${formatearPrecio(precioConDescuento)}</span>
            </div>
          `;
        } else {
          // Si no hay descuento real, mantener el precio original sin modificar
          // console.log('No hay descuento real aplicado, manteniendo precio original');
        }
      }
      
      // ACTUALIZAR precio sin impuestos cuando hay precio tachado - usar precio de oferta
      actualizarPrecioSinImpuestosConOferta(card);
    } else {
      const priceElement = card.querySelector('.price');
      if (priceElement) {
        const precio = lopObtenerPrecioBasePesosTarjeta(card);
        if (precio > 0) {
          const precioConDescuento = aplicarDescuentoFicticio(precio, porcentajeDescuento);
          const precioOriginal = precio;
          const hayDescuentoReal = precioConDescuento < precioOriginal;

          if (hayDescuentoReal) {
            priceElement.innerHTML = `
              <div class="LOP-precios-descuento-container LOP-precios-responsive" style="display: flex !important; align-items: center !important; gap: 8px !important;">
                <span class="LOP-precio-original-tachado" style="color: #141215 !important; font-size: 15.25px !important; font-weight: 400 !important; line-height: 22.4px !important; text-decoration-line: line-through !important;">
                  $${formatearPrecio(precioOriginal)}
                </span>
                <span class="LOP-precio-descuento" style="color: #368617 !important; font-weight: 700 !important; line-height: 22.4px !important;">$${formatearPrecio(precioConDescuento)}</span>
              </div>
            `;
          }
        }
      }
    }
    
    // Actualizar precio sin impuestos y cuotas después de aplicar descuento
    actualizarPrecioSinImpuestosConOferta(card);
    actualizarCuotasDespuesDescuento(card);
  }
  
  // Función para actualizar las cuotas basándose en el precio con descuento si existe
  function actualizarCuotasDespuesDescuento(container) {
    const body = document.body;
    if (!body) return;
    
    const enableInstallments = body.getAttribute('data-lop-enable-installments');
    if (enableInstallments !== 'true') return;
    
    // Buscar el precio con descuento en el contenedor
    const precioDescuentoElement = container.querySelector('.LOP-precio-descuento');
    if (!precioDescuentoElement) return;
    
    // Extraer el precio con descuento
    const precioDescuentoText = precioDescuentoElement.textContent.replace(/[^\d]/g, '');
    if (!precioDescuentoText) return;
    
    const precioBaseCuotas = parseInt(precioDescuentoText);
    if (!precioBaseCuotas || precioBaseCuotas <= 0) return;
    
    // Obtener configuración de cuotas
    let installmentsCount = 9;
    let bgColor = '#FFE5E5';
    let textColor = '#222222';
    
    const countFromBody = body.getAttribute('data-lop-installments-count');
    const bgFromBody = body.getAttribute('data-lop-installments-bg-color');
    const textFromBody = body.getAttribute('data-lop-installments-text-color');
    
    if (countFromBody) installmentsCount = parseInt(countFromBody) || 9;
    if (bgFromBody) bgColor = bgFromBody;
    if (textFromBody) textColor = textFromBody;
    
    // Calcular el monto por cuota
    const installmentAmount = Math.round(precioBaseCuotas / installmentsCount);
    const installmentAmountStr = formatearPrecio(installmentAmount);
    
    const installmentsHtml = `<div class="lop-installments-container" style="background-color: ${bgColor}; color: ${textColor};"><span>${installmentsCount} cuotas de $${installmentAmountStr} sin interes</span></div>`;

    // Quitar cualquier bloque previo (p. ej. duplicado al final del sticky-scroller en PDP)
    container.querySelectorAll('.lop-installments-container').forEach((el) => el.remove());

    // PDP: mismo lugar que Liquid (después de impuestos / precio), no al final del sticky-scroller
    const priceContainers = container.querySelectorAll('.product--price-container');
    if (priceContainers.length > 0) {
      priceContainers.forEach((priceCol) => {
        const anchor =
          priceCol.querySelector('.product-price-without-taxes:not(.product-price-without-taxes-personalizado)') ||
          priceCol.querySelector('.product-price-without-taxes-personalizado') ||
          priceCol.querySelector('[id^="price-"]');
        if (anchor) {
          anchor.insertAdjacentHTML('afterend', installmentsHtml);
        } else {
          priceCol.insertAdjacentHTML('beforeend', installmentsHtml);
        }
      });
      return;
    }

    // PLP / tarjetas: debajo del bloque de info de la card
    const infoInner =
      container.querySelector('.product-card-info--inner') ||
      container.querySelector('sticky-scroller.product-information') ||
      container.querySelector('.product-information') ||
      container;
    infoInner.insertAdjacentHTML('beforeend', installmentsHtml);
  }

  // Función para actualizar el precio sin impuestos cuando hay precio tachado (oferta)
  function actualizarPrecioSinImpuestosConOferta(container) {
    const precioOfertaElement = container.querySelector('.LOP-precio-descuento');
    if (!precioOfertaElement) {
      return;
    }

    const precioOfertaText = precioOfertaElement.textContent.replace(/[^\d]/g, '');
    if (!precioOfertaText) return;

    const precioOferta = parseInt(precioOfertaText, 10);
    if (precioOferta <= 0) return;

    const impuesto = obtenerImpuestoProducto(container);
    const divisor = 1 + (impuesto / 100);
    const precioSinImpuesto = Math.round(precioOferta / divisor);
    const precioSinImpuestoStr = formatearPrecio(precioSinImpuesto);
    const textoPrecioSinImpuestos = obtenerTextoPrecioSinImpuestos(precioSinImpuestoStr);

    const infoInner = container.querySelector('.product-card-info--inner, .sticky-scroller, .product--price-container');
    const smallStyle = 'font-family: var(--font-crocs-regular), Arial, sans-serif;';

    // Snippet theme: product-price-without-taxes.liquid suele usar <small>etiqueta</small> + <span>importe</span>.
    // Solo actualizar el <small> dejaba el <span> viejo (p. ej. monto del compare_at) → dos importes en una línea.
    container.querySelectorAll('.product-price-without-taxes').forEach(function (block) {
      if (block.classList.contains('product-price-without-taxes-personalizado')) return;
      block.innerHTML = `<small style="${smallStyle}">${textoPrecioSinImpuestos}</small>`;
    });

    container.querySelectorAll('.product-price-without-taxes-personalizado small').forEach(function (sm) {
      sm.textContent = textoPrecioSinImpuestos;
    });

    const tieneBloqueSinImpuestos =
      container.querySelector('.product-price-without-taxes') ||
      container.querySelector('.product-price-without-taxes-personalizado');

    if (!tieneBloqueSinImpuestos && infoInner) {
      const prevNoTax = infoInner.querySelector('.product-price-without-taxes-personalizado');
      if (prevNoTax) prevNoTax.remove();

      const existingInstallments = infoInner.querySelector('.lop-installments-container');
      if (existingInstallments) {
        existingInstallments.remove();
      }

      const priceNoTaxHtml = `<div class="product-price-without-taxes-personalizado" style="margin-top: 4px;">
        <small style="font-family: var(--font-crocs-regular), Arial, sans-serif;">${textoPrecioSinImpuestos}</small>
      </div>`;

      infoInner.insertAdjacentHTML('beforeend', priceNoTaxHtml);
      console.log(`✅ Precio sin impuestos creado con precio de oferta: $${precioSinImpuestoStr}`);

      if (existingInstallments) {
        infoInner.appendChild(existingInstallments);
      }
    }

    // La posición de cuotas la fija `actualizarCuotasDespuesDescuento` (junto al precio en PDP)
  }

  // FUNCIÓN para obtener precio real del producto
  function obtenerPrecioReal(productCard) {
    const lopPrecio = productCard.querySelector('.LOP-precio-descuento');
    if (lopPrecio) {
      const digits = lopPrecio.textContent.replace(/[^\d]/g, '');
      if (digits) {
        const n = parseInt(digits, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }

    const productPrice = productCard.getAttribute('data-product-price');
    if (productPrice) {
      const n = parseInt(String(productPrice).replace(/[^\d]/g, ''), 10);
      if (!isNaN(n) && n > 0) return n;
    }

    const productHandle = productCard.getAttribute('data-product-handle');
    const globalJson = document.getElementById('agrupadores-precios-json-global');
    if (globalJson && productHandle) {
      try {
        const agrupadores = JSON.parse(globalJson.textContent);
        for (const [, productos] of Object.entries(agrupadores)) {
          if (Array.isArray(productos)) {
            const producto = productos.find(p => p.handle === productHandle);
            if (producto && producto.price) {
              return producto.price;
            }
          }
        }
      } catch (e) {
        console.log('Error buscando precio en JSON global:', e);
      }
    }

    const insAmt = productCard.querySelector('.price ins .amount, .price ins .money');
    if (insAmt) {
      const priceMatch = insAmt.textContent.replace(/[^\d]/g, '');
      if (priceMatch) {
        const n = parseInt(priceMatch, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    const precioMin = productCard.querySelector('.price .amount.precio-minimo');
    if (precioMin) {
      const priceMatch = precioMin.textContent.replace(/[^\d]/g, '');
      if (priceMatch) {
        const n = parseInt(priceMatch, 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }

    return 6999;
  }

  // FUNCIÓN para obtener impuesto del producto
  function obtenerImpuestoProducto(productCard) {
    // PRIMERO: Buscar metafield de impuestos en data attributes
    const impuesto = productCard.getAttribute('data-impuesto-nacional');
    if (impuesto) {
      const impuestoValue = parseFloat(impuesto);
      if (!isNaN(impuestoValue) && impuestoValue > 0) {
        return impuestoValue;
      }
    }
    
    // SEGUNDO: Buscar metafield de impuestos en el DOM
    const impuestoElement = productCard.querySelector('[data-impuesto-nacional]');
    if (impuestoElement) {
      const impuestoValue = parseFloat(impuestoElement.getAttribute('data-impuesto-nacional'));
      if (!isNaN(impuestoValue) && impuestoValue > 0) {
        return impuestoValue;
      }
    }
    
    // Fallback: impuesto por defecto
    return 21.0;
  }

  // FUNCIÓN para forzar visibilidad de precios por defecto
  function forzarPreciosPorDefecto() {
    const cards = document.querySelectorAll('.product-card');
    let cardsFixed = 0;
    
    cards.forEach(card => {
      // Si la tarjeta no tiene precios personalizados, forzar visibilidad de precios por defecto
      const hasCustomPrice = card.querySelector('.precio-personalizado-container');
      const hasCustomNoTax = card.querySelector('.product-price-without-taxes-personalizado');
      
      if (!hasCustomPrice && !hasCustomNoTax) {
        // Buscar precios por defecto que puedan estar ocultos
        const defaultPrices = card.querySelectorAll('.price, .product-price-without-taxes');
        
        if (defaultPrices.length === 0) {
          // Si no hay precios por defecto en el DOM, crearlos
          const infoInner = card.querySelector('.product-card-info--inner');
          if (infoInner) {
            // Obtener precio real del producto
            const precioReal = obtenerPrecioReal(card);
            const precioFormateado = formatearPrecio(precioReal);
            
            // Obtener impuesto del producto
            const impuesto = obtenerImpuestoProducto(card);
            const divisor = 1 + (impuesto / 100);
            const precioSinImpuesto = Math.round((precioReal / divisor));
            const precioSinImpuestoStr = formatearPrecio(precioSinImpuesto);
            const textoPrecioSinImpuestos = obtenerTextoPrecioSinImpuestos(precioSinImpuestoStr);
            
            // Guardar referencia a las cuotas si existen para reubicarlas después
            const existingInstallments = infoInner.querySelector('.lop-installments-container');
            if (existingInstallments) {
              existingInstallments.remove();
            }
            
            // Crear precio por defecto con estilo personalizado
            const priceHtml = `<div class="precio-personalizado-container" style="margin: 8px 0; display: block;">
              <span class="precio-minimo" style="color: #222; font-size: 18px; font-weight: bold; font-family: var(--font-crocs-regular), Arial, sans-serif;">$${precioFormateado}</span>
            </div>
            <div class="product-price-without-taxes-personalizado" style="margin-top: 4px;">
              <small style="font-family: var(--font-crocs-regular), Arial, sans-serif;">${textoPrecioSinImpuestos}</small>
            </div>`;
            
            infoInner.insertAdjacentHTML('beforeend', priceHtml);
            
            // Si había cuotas, re-insertarlas al final (después del precio sin impuestos)
            if (existingInstallments) {
              infoInner.appendChild(existingInstallments);
            }
            cardsFixed++;
          }
        } else {
          // Forzar visibilidad de precios existentes
          defaultPrices.forEach(price => {
            price.style.display = 'block';
            price.style.visibility = 'visible';
            price.style.opacity = '1';
            price.style.position = 'static';
            price.style.clip = 'auto';
            price.style.height = 'auto';
            price.style.width = 'auto';
            price.style.margin = '';
            price.style.padding = '';
            price.style.overflow = 'visible';
          });
          cardsFixed++;
        }
      }
    });
    
    if (cardsFixed > 0) {
      console.log(`✅ Forzados precios por defecto en ${cardsFixed} tarjetas`);
    }
  }

  // Ejecutar después de un tiempo para asegurar que se muestren los precios por defecto
  setTimeout(() => {
    forzarPreciosPorDefecto();

    procesarDescuentosFicticios();
    procesarDescuentosFicticiosProducto();
    
    // Debug temporal para producto individual
    const productDetail = document.querySelector('.thb-product-detail.product');
    if (productDetail) {
      const descuento = productDetail.getAttribute('data-collection-descuento');
      const cucarda = productDetail.getAttribute('data-collection-cucarda-titulo');
      const colorTitulo = productDetail.getAttribute('data-collection-cucarda-color-titulo');
      const colorDescuento = productDetail.getAttribute('data-collection-cucarda-color-descuento');
      
      console.log('🔍 Producto individual metafields:', { 
        descuento, 
        cucarda, 
        colorTitulo, 
        colorDescuento 
      });
      
      // Verificar contenedor de precios
      const precioContainer = productDetail.querySelector('.sticky-scroller .precio-personalizado-container') || productDetail.querySelector('.precio-personalizado-container');
      console.log('🔍 Contenedor de precios:', precioContainer ? 'Encontrado' : 'No encontrado');
      
      if (precioContainer) {
        const precioMin = precioContainer.querySelector('.precio-minimo');
        const precioMax = precioContainer.querySelector('.precio-maximo');
        console.log('🔍 Elementos de precio:', {
          precioMin: precioMin ? precioMin.textContent : 'No encontrado',
          precioMax: precioMax ? precioMax.textContent : 'No encontrado'
        });
      }
      
      if (descuento || cucarda) {
        const cucardas = productDetail.querySelectorAll('.LOP-cucarda-descuento');
        console.log(`✅ Cucardas encontradas en producto individual: ${cucardas.length}`);
        cucardas.forEach((cucarda, index) => {
          console.log(`  Cucarda ${index + 1}: "${cucarda.textContent}" - Top: ${cucarda.style.top} - Clases: ${cucarda.className}`);
        });
      }
    }
  }, 1000);
  setTimeout(() => {
    forzarPreciosPorDefecto();

    procesarDescuentosFicticios();
    procesarDescuentosFicticiosProducto();
  }, 2000);
  setTimeout(() => {
    forzarPreciosPorDefecto();

    procesarDescuentosFicticios();
    procesarDescuentosFicticiosProducto();
  }, 3000);

  // EJECUTAR LA PRIMERA VEZ (ya se ejecuta dentro de initializeSwatches)
  // procesarPreciosProductos(); // <-- Comentado porque ya se ejecuta arriba

  setTimeout(() => {
    procesarDescuentosFicticios();
    procesarDescuentosFicticiosProducto();
  }, 100);

// FUNCIÓN TEMPORAL DE DEBUG: Forzar lectura de settings
window.lopForceSettingsReload = function() {
  console.log('🔧 FORZANDO recarga de settings...');
  
  // Mostrar configuración actual de Shopify
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings) {
    console.log('📋 Settings actuales:', {
      enabled: window.Shopify.theme.settings.lop_enable_color_swatches,
      hasJson: !!window.Shopify.theme.settings.lop_color_map_json,
      jsonLength: window.Shopify.theme.settings.lop_color_map_json ? window.Shopify.theme.settings.lop_color_map_json.length : 0,
      jsonStart: window.Shopify.theme.settings.lop_color_map_json ? window.Shopify.theme.settings.lop_color_map_json.substring(0, 100) + '...' : 'No disponible'
    });
  }
  
  // Forzar carga desde settings
  colorMap = loadColorMapFromSettings();
  
  console.log('🎯 ColorMap después de forzar:', {
    totalColores: Object.keys(colorMap).length,
    tieneNegroImagen: colorMap['Negro'] && colorMap['Negro'].includes('image:'),
    negroValue: colorMap['Negro']
  });
  
  // Reprocesar swatches
  if (typeof initializeSwatches === 'function') {
    initializeSwatches('force-settings-reload');
  } else {
    console.log('⚠️ initializeSwatches no disponible, ejecutando procesarPreciosProductos directamente');
    if (typeof procesarPreciosProductos === 'function') {
      procesarPreciosProductos();
    }
  }
};

console.log('🔧 Función temporal disponible: lopForceSettingsReload()');

// FUNCIÓN LOP: Detectar y ocultar swatches con imágenes de placeholder
function detectarYOcultarSwatchesPlaceholder() {
  console.log('=== Detectando swatches con placeholder ===');
  
  // Buscar todos los swatch-item que tengan imágenes
  const swatchItems = document.querySelectorAll('.swatch-item');
  
  swatchItems.forEach(swatchItem => {
    const img = swatchItem.querySelector('img');
    if (img) {
      // Crear función para verificar si es placeholder
      const verificarPlaceholder = () => {
        const src = img.src || img.getAttribute('src');
        
        // Detectar imágenes de placeholder de Shopify
        if (src && (
          src.includes('no-image') || 
          src.includes('placeholder') ||
          src.includes('shopifycloud/storefront/assets') ||
          src.includes('2a702f30_80x80') ||
          (src.endsWith('.gif') && src.includes('assets'))
        )) {
          console.log('Swatch con placeholder detectado, ocultando:', src);
          swatchItem.style.display = 'none';
          swatchItem.classList.add('LOP-swatch-hidden-placeholder');
          return true;
        }
        return false;
      };
      
      // Verificar inmediatamente si ya está cargada
      if (img.complete) {
        verificarPlaceholder();
      } else {
        // Agregar event listeners para cuando cargue
        img.addEventListener('load', verificarPlaceholder);
        img.addEventListener('error', () => {
          console.log('Error cargando imagen de swatch, ocultando');
          swatchItem.style.display = 'none';
          swatchItem.classList.add('LOP-swatch-hidden-error');
        });
      }
    }
  });
}

// Ejecutar la función cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', detectarYOcultarSwatchesPlaceholder);

// También ejecutar cuando se cargan nuevos swatches via AJAX
window.lopDetectarSwatchesPlaceholder = detectarYOcultarSwatchesPlaceholder;
  
